"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8926],{

/***/ 55856:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ar": () => (/* binding */ ListingSpan),
/* harmony export */   "B1": () => (/* binding */ InsuranceBookedPackStyle),
/* harmony export */   "ML": () => (/* binding */ ViewPlanBenefitStyle),
/* harmony export */   "RW": () => (/* binding */ GreenArrowWrap),
/* harmony export */   "UH": () => (/* binding */ InsuranceBookedStyle)
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82740);
/* harmony import */ var _tm_utility_global__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42874);
/* harmony import */ var _tm_static_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84576);



const InsuranceBookedStyle = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "InsuranceBookedstyle__InsuranceBookedStyle",
  componentId: "sc-16uf35k-0"
})(["background-color:", ";border-radius:8px;padding:28px 26px;min-height:295px;@media ", "{min-height:0;padding:12px 16px;}"], _tm_utility_global__WEBPACK_IMPORTED_MODULE_1__/* .theme.neonGreen */ .rS.neonGreen, _tm_static_utils__WEBPACK_IMPORTED_MODULE_2__/* .deviceType.mobile */ .vO.mobile);
const ListingSpan = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].span.withConfig */ .ZP.span.withConfig({
  displayName: "InsuranceBookedstyle__ListingSpan",
  componentId: "sc-16uf35k-1"
})(["font-size:14px;line-height:20px;color:", ";padding-right:12px;margin-right:12px;position:relative;flex-shrink:0;&:last-child{border:none;flex-shrink:unset;}&:after{content:\"\";position:absolute;right:0;top:4px;width:1px;height:14px;background:#4a4a4a;}&:last-child:after{width:0;border:none;flex-shrink:unset;}@media ", "{font-size:12px;}"], _tm_utility_global__WEBPACK_IMPORTED_MODULE_1__/* .theme.greyText */ .rS.greyText, _tm_static_utils__WEBPACK_IMPORTED_MODULE_2__/* .deviceType.mobile */ .vO.mobile);
const GreenArrowWrap = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "InsuranceBookedstyle__GreenArrowWrap",
  componentId: "sc-16uf35k-2"
})(["transition:0.4s ease-in;transform-origin:center;flex-shrink:0;width:40px;height:40px;display:flex;", ""], p => p.showinsDetails && `
transform:rotate(180deg);
`);
const InsuranceBookedPackStyle = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "InsuranceBookedstyle__InsuranceBookedPackStyle",
  componentId: "sc-16uf35k-3"
})(["display:flex;flex-direction:column;border-bottom:1px solid ", ";padding-bottom:8px;margin-bottom:24px;@media ", "{padding-bottom:12px;margin-bottom:12px;}"], _tm_utility_global__WEBPACK_IMPORTED_MODULE_1__/* .theme.lightSilver */ .rS.lightSilver, _tm_static_utils__WEBPACK_IMPORTED_MODULE_2__/* .deviceType.mobile */ .vO.mobile);
const ViewPlanBenefitStyle = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "InsuranceBookedstyle__ViewPlanBenefitStyle",
  componentId: "sc-16uf35k-4"
})(["display:flex;align-items:center;justify-content:space-between;border-bottom:none;margin-bottom:20px;gap:8px;@media ", "{flex-direction:column;gap:4px;align-items:flex-start;margin-bottom:12px;}"], _tm_static_utils__WEBPACK_IMPORTED_MODULE_2__/* .deviceType.mobile */ .vO.mobile);

/***/ }),

/***/ 72425:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ InsuranceBooked_InsuranceBooked)
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/index.tsx + 12 modules
var components = __webpack_require__(48359);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/index.ts + 2 modules
var src = __webpack_require__(87109);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../libs/utility/src/lib/insurance/utils/index.ts + 5 modules
var utils = __webpack_require__(62663);
// EXTERNAL MODULE: ../../libs/isomorphic-utils/src/index.ts + 7 modules
var isomorphic_utils_src = __webpack_require__(44928);
// EXTERNAL MODULE: ../../libs/ui/src/lib/hooks/useBreakpoint/index.tsx
var useBreakpoint = __webpack_require__(53293);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/InsuranceBooked/InsuranceBooked.style.ts
var InsuranceBooked_style = __webpack_require__(55856);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/InsuranceBooked/InsuranceBookedTravel.tsx










const InsuranceBookedTravel = ({
  selectedPlanData
}) => {
  const device = (0,useBreakpoint/* useBreakpoint */.G)();
  const {
    countryTitle,
    travelDate,
    travellerCount,
    travelPurpose
  } = selectedPlanData || {};
  const {
    startDate,
    endDate
  } = travelDate || {};
  console.log({
    travelPurpose,
    travellerCount
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.H6Tag, {
      color: Global/* theme.greyText */.rS.greyText,
      "data-test-id": "InsuranceBookedTravel-H6Tag",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
        value: countryTitle,
        "data-test-id": "InsuranceBookedTravel-FormattedText"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components.FlexComp, {
      margin: device == "lg" ? "8px 0 0" : "",
      "data-test-id": "InsuranceBookedTravel-FlexComp",
      children: [startDate && endDate && /*#__PURE__*/(0,jsx_runtime.jsxs)(InsuranceBooked_style/* ListingSpan */.Ar, {
        color: Global/* theme.greyText */.rS.greyText,
        "data-test-id": "InsuranceBookedTravel-ListingSpan",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components.SpanTag, {
          color: Global/* theme.greyText */.rS.greyText,
          fontSize: "md",
          fontWeight: "bold",
          "data-test-id": "InsuranceBookedTravel-SpanTag",
          children: [(0,utils/* formatDate */.p6)(startDate, isomorphic_utils_src.DATE_FORMATS["D MMM"]), "'"]
        }), (0,utils/* formatDate */.p6)(startDate, isomorphic_utils_src.DATE_FORMATS.YY), " -To-", " ", /*#__PURE__*/(0,jsx_runtime.jsxs)(components.SpanTag, {
          color: Global/* theme.greyText */.rS.greyText,
          fontSize: "md",
          fontWeight: "bold",
          "data-test-id": "InsuranceBookedTravel-SpanTag",
          children: [(0,utils/* formatDate */.p6)(endDate, isomorphic_utils_src.DATE_FORMATS["D MMM"]), "'"]
        }), (0,utils/* formatDate */.p6)(endDate, isomorphic_utils_src.DATE_FORMATS.YY)]
      }), travellerCount && /*#__PURE__*/(0,jsx_runtime.jsx)(InsuranceBooked_style/* ListingSpan */.Ar, {
        color: Global/* theme.greyText */.rS.greyText,
        "data-test-id": "InsuranceBookedTravel-ListingSpan",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
          value: travellerCount,
          "data-test-id": "InsuranceBookedTravel-FormattedText"
        })
      })]
    })]
  });
};

/* harmony default export */ const InsuranceBooked_InsuranceBookedTravel = (InsuranceBookedTravel);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/InsuranceBooked/InsuranceBookedPack.tsx







const InsuranceBookedPack = ({
  selectedPlanData,
  viewBenefitsCta,
  handleViewBenefits
}) => {
  const device = (0,src/* useBreakpointV2 */.bU)();
  const {
    planType,
    planName,
    vendorName,
    vendorIcon,
    settleMentRatio,
    planTypeColor
  } = selectedPlanData || {};
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(InsuranceBooked_style/* InsuranceBookedPackStyle */.B1, {
    "data-test-id": "InsuranceBookedPack-InsuranceBookedPackStyle",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.ParaTag, {
      fontSize: "xs",
      fontWeight: "black",
      "data-test-id": "InsuranceBookedPack-ParaTag",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
        value: planType,
        "data-test-id": "InsuranceBookedPack-FormattedText"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(InsuranceBooked_style/* ViewPlanBenefitStyle */.ML, {
      "data-test-id": "InsuranceBookedPack-ViewPlanBenefitStyle",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
        fontWeight: "black",
        fontSize: "md",
        color: Global/* theme.blackText */.rS.blackText,
        "data-test-id": "InsuranceBookedPack-SpanTag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
          value: planName,
          "data-test-id": "InsuranceBookedPack-FormattedText"
        })
      }), viewBenefitsCta && /*#__PURE__*/(0,jsx_runtime.jsx)(components.AnchorTag, {
        fontSize: "sm",
        fontWeight: "black",
        handleClick: handleViewBenefits,
        "data-test-id": "InsuranceBookedPack-AnchorTag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
          value: viewBenefitsCta,
          "data-test-id": "InsuranceBookedPack-FormattedText"
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components.FlexComp, {
      alignItems: "center",
      borderBottom: "none",
      padding: "0",
      gap: "14px",
      margin: "0",
      "data-test-id": "InsuranceBookedPack-FlexComp",
      children: [vendorIcon && /*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
        width: "48px",
        height: "48px",
        src: vendorIcon,
        "data-test-id": "InsuranceBookedPack-ImageComponent"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.ParaTag, {
          fontSize: "sm",
          fontWeight: "black",
          color: Global/* theme.blackText */.rS.blackText,
          "data-test-id": "InsuranceBookedPack-ParaTag",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
            value: vendorName,
            "data-test-id": "InsuranceBookedPack-FormattedText"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
          fontSize: "xs",
          color: Global/* theme.blackText */.rS.blackText,
          "data-test-id": "InsuranceBookedPack-SpanTag",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
            value: settleMentRatio,
            "data-test-id": "InsuranceBookedPack-FormattedText"
          })
        })]
      })]
    })]
  });
};

/* harmony default export */ const InsuranceBooked_InsuranceBookedPack = (InsuranceBookedPack);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/InsuranceBooked/InsuranceBooked.tsx










const InsuranceBooked = ({
  title,
  selectedPlanData,
  viewBenefitsCta,
  handleViewBenefits
}) => {
  const {
    payAmtTxt,
    payAmt
  } = selectedPlanData || {};
  const device = (0,src/* useBreakpointV2 */.bU)();
  const {
    0: insDetails,
    1: setInsDetails
  } = (0,react.useState)(false);

  const handleInsuranceExpand = () => {
    setInsDetails(!insDetails);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(InsuranceBooked_style/* InsuranceBookedStyle */.UH, {
    "data-test-id": "InsuranceBooked-InsuranceBookedStyle",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components.FlexComp, {
      justifyContent: "space-between",
      alignItems: device == "lg" ? "center" : "flex-start",
      borderBottom: insDetails && device == "sm" ? "1px solid #d8d8d8" : device == "lg" ? "1px solid #d8d8d8" : "",
      padding: insDetails && device == "sm" ? "0 0 12px" : device == "lg" ? "0 0 24px" : "",
      margin: insDetails && device == "sm" ? "0 0 12px" : device == "lg" ? "0 0 8px" : "",
      handleClick: handleInsuranceExpand,
      "data-test-id": "InsuranceBooked-FlexComp",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components.FlexComp, {
        justifyContent: "space-between",
        width: "100%",
        alignItems: device === "lg" ? "center" : "",
        flexDirection: device === "lg" ? "row" : "column",
        "data-test-id": "InsuranceBooked-FlexComp",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components.FlexComp, {
          alignItems: "center",
          gap: "8px",
          padding: "0",
          margin: "0 10px 0 0",
          borderBottom: "none",
          "data-test-id": "InsuranceBooked-FlexComp",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
            width: "24px",
            height: "24px",
            src: "https://tripmoneycmsimgak.mmtcdn.com/img/Frame_48_Copy_4b90426dd9.svg",
            "data-test-id": "InsuranceBooked-ImageComponent"
          }), device == "lg" ? /*#__PURE__*/(0,jsx_runtime.jsx)(components.H5Tag, {
            color: Global/* theme.blackText */.rS.blackText,
            "data-test-id": "InsuranceBooked-H5Tag",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
              value: title,
              "data-test-id": "InsuranceBooked-FormattedText"
            })
          }) : /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.H6Tag, {
              color: Global/* theme.blackText */.rS.blackText,
              "data-test-id": "InsuranceBooked-H6Tag",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
                value: title,
                "data-test-id": "InsuranceBooked-FormattedText"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components.FlexComp, {
              flexShrink: "0",
              flexDirection: "row",
              gap: "2px",
              "data-test-id": "InsuranceBooked-FlexComp",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
                color: Global/* theme.greenText5 */.rS.greenText5,
                fontSize: "xs",
                "data-test-id": "InsuranceBooked-SpanTag",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
                  value: payAmtTxt,
                  "data-test-id": "InsuranceBooked-FormattedText"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
                color: Global/* theme.greenText5 */.rS.greenText5,
                fontSize: "xs",
                fontWeight: "black",
                "data-test-id": "InsuranceBooked-SpanTag",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
                  value: payAmt,
                  "data-test-id": "InsuranceBooked-FormattedText"
                })
              })]
            })]
          })]
        }), device === "lg" && /*#__PURE__*/(0,jsx_runtime.jsxs)(components.FlexComp, {
          flexDirection: "row",
          gap: "4px",
          margin: device === "lg" ? "0 0 0 auto" : "",
          "data-test-id": "InsuranceBooked-FlexComp",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
            color: Global/* theme.greenText5 */.rS.greenText5,
            fontSize: device == "lg" ? "md" : "xs",
            "data-test-id": "InsuranceBooked-SpanTag",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
              value: payAmtTxt,
              "data-test-id": "InsuranceBooked-FormattedText"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
            color: Global/* theme.greenText5 */.rS.greenText5,
            fontSize: device == "lg" ? "md" : "xs",
            fontWeight: "black",
            "data-test-id": "InsuranceBooked-SpanTag",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
              value: payAmt,
              "data-test-id": "InsuranceBooked-FormattedText"
            })
          })]
        })]
      }), device == "sm" && /*#__PURE__*/(0,jsx_runtime.jsx)(InsuranceBooked_style/* GreenArrowWrap */.RW, {
        showinsDetails: insDetails,
        onClick: handleInsuranceExpand,
        "data-test-id": "InsuranceBooked-GreenArrowWrap",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
          width: "40px",
          height: "40px",
          src: "https://tripmoneycmsimgak.mmtcdn.com/img/Frame_1244832110_61908827b9.svg",
          "data-test-id": "InsuranceBooked-ImageComponent"
        })
      })]
    }), (insDetails && device == "sm" || device == "lg") && /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(InsuranceBooked_InsuranceBookedPack, {
        selectedPlanData: selectedPlanData,
        viewBenefitsCta: viewBenefitsCta,
        handleViewBenefits: handleViewBenefits,
        "data-test-id": "InsuranceBooked-InsuranceBookedPack"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(InsuranceBooked_InsuranceBookedTravel, {
        selectedPlanData: selectedPlanData,
        "data-test-id": "InsuranceBooked-InsuranceBookedTravel"
      })]
    })]
  });
};

/* harmony default export */ const InsuranceBooked_InsuranceBooked = (InsuranceBooked);

/***/ }),

/***/ 73642:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _InsuranceBooked_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55856);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);



const InsuranceBookedShimmer = () => {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_InsuranceBooked_style__WEBPACK_IMPORTED_MODULE_0__/* .InsuranceBookedStyle */ .UH, {
    "data-test-id": "InsuranceBookedShimmer-InsuranceBookedStyle"
  });
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (InsuranceBookedShimmer);

/***/ }),

/***/ 93626:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _tm_static__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48359);
/* harmony import */ var _InsurancePlans_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5563);
/* harmony import */ var _tm_utility_global__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42874);
/* harmony import */ var _tm_ui_widgets__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87109);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52322);








const BenefitItem = ({
  data,
  benefitName,
  isAddOnBenefits
}) => {
  const device = (0,_tm_ui_widgets__WEBPACK_IMPORTED_MODULE_4__/* .useBreakpointV2 */ .bU)();
  const {
    0: benefitOpen,
    1: setBenefit
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true);

  const handleBenefit = () => {
    setBenefit(!benefitOpen);
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.FlexComp, {
      alignItems: "center",
      justifyContent: "space-between",
      gap: device == "lg" ? "24px" : "16px",
      handleClick: handleBenefit,
      "data-test-id": "BenefitItem-FlexComp",
      children: [benefitName && isAddOnBenefits ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_InsurancePlans_style__WEBPACK_IMPORTED_MODULE_2__/* .BenefitName */ .Tu, {
        color: device == "lg" ? _tm_utility_global__WEBPACK_IMPORTED_MODULE_3__/* .theme.greyText */ .rS.greyText : _tm_utility_global__WEBPACK_IMPORTED_MODULE_3__/* .theme.greyText7 */ .rS.greyText7,
        "data-test-id": "BenefitItem-BenefitName",
        children: benefitName
      }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_InsurancePlans_style__WEBPACK_IMPORTED_MODULE_2__/* .BenefitName */ .Tu, {
        color: device == "lg" ? _tm_utility_global__WEBPACK_IMPORTED_MODULE_3__/* .theme.greyText */ .rS.greyText : _tm_utility_global__WEBPACK_IMPORTED_MODULE_3__/* .theme.greyText7 */ .rS.greyText7,
        "data-test-id": "BenefitItem-BenefitName",
        children: [data && data.length, " \xA0", benefitName]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_InsurancePlans_style__WEBPACK_IMPORTED_MODULE_2__/* .EmptyBorder */ .T7, {
        "data-test-id": "BenefitItem-EmptyBorder"
      }), !isAddOnBenefits && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_InsurancePlans_style__WEBPACK_IMPORTED_MODULE_2__/* .GreyChevWrap */ ._L, {
        chevOpen: benefitOpen,
        "data-test-id": "BenefitItem-GreyChevWrap",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.ImageComponent, {
          width: "32px",
          height: "32px",
          src: "https://tripmoneycmsimgak.mmtcdn.com/img/Grey_Bg_Chev_81a870a4f8.svg",
          "data-test-id": "BenefitItem-ImageComponent"
        })
      })]
    }), benefitOpen && data && data?.map((item2, index2) => {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.FlexComp, {
        alignItems: "flex-start",
        gap: "20px",
        "data-test-id": `BenefitItem-FlexComp-${index2}`,
        children: [item2.icon && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.ImageComponent, {
          src: item2.icon,
          height: device == "lg" ? "30" : "20px",
          width: device == "lg" ? "30" : "20px",
          "data-test-id": "BenefitItem-ImageComponent"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.FlexComp, {
          width: "100%",
          flexDirection: "column",
          "data-test-id": "BenefitItem-FlexComp",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.FlexComp, {
            justifyContent: "space-between",
            gap: "8px",
            "data-test-id": "BenefitItem-FlexComp",
            children: [item2.title && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.SpanTag, {
              fontSize: "sm",
              fontWeight: "black",
              color: _tm_utility_global__WEBPACK_IMPORTED_MODULE_3__/* .theme.blackText */ .rS.blackText,
              "data-test-id": "BenefitItem-SpanTag",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.FormattedText, {
                value: item2.title,
                "data-test-id": "BenefitItem-FormattedText"
              })
            }), item2.price && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_InsurancePlans_style__WEBPACK_IMPORTED_MODULE_2__/* .BenefitPrice */ .Ob, {
              txtfontSize: "xs",
              txtcolor: _tm_utility_global__WEBPACK_IMPORTED_MODULE_3__/* .theme.greenText */ .rS.greenText,
              txtfontWeight: "bold",
              "data-test-id": "BenefitItem-BenefitPrice",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.FormattedText, {
                value: item2.price,
                "data-test-id": "BenefitItem-FormattedText"
              })
            })]
          }), item2.info && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.SpanTag, {
            fontSize: "xs",
            color: _tm_utility_global__WEBPACK_IMPORTED_MODULE_3__/* .theme.greyText */ .rS.greyText,
            "data-test-id": "BenefitItem-SpanTag",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.FormattedText, {
              value: item2.info,
              "data-test-id": "BenefitItem-FormattedText"
            })
          })]
        })]
      }, index2);
    })]
  });
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (BenefitItem);

/***/ }),

/***/ 53952:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ InsurancePlans_InsPlanModalCommonInfo)
});

// EXTERNAL MODULE: ../../libs/utility/src/lib/insurance/utils/index.ts + 5 modules
var utils = __webpack_require__(62663);
// EXTERNAL MODULE: ../../libs/isomorphic-utils/src/index.ts + 7 modules
var src = __webpack_require__(44928);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/index.tsx + 12 modules
var components = __webpack_require__(48359);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/InsurancePlans/InsurancePlans.style.ts
var InsurancePlans_style = __webpack_require__(5563);
// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/OmnitureAnalytics/insurance/index.ts + 5 modules
var insurance = __webpack_require__(83636);
// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/XDMAnalytics/index.ts
var XDMAnalytics = __webpack_require__(50354);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/InsurancePlans/MoreBenefits/MoreBenefits.style.ts
 // Dropdown Modal Styles

const DropdownModalContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "MoreBenefitsstyle__DropdownModalContainer",
  componentId: "sc-1vkom6t-0"
})(["position:absolute;top:100%;left:0;background:white;border:1px solid #e2e2e2;border-radius:4px;padding:12px;z-index:1000;min-width:200px;max-width:280px;box-shadow:0 1px 7px 0px rgba(0,0,0,0.2);"]);
const DropdownContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "MoreBenefitsstyle__DropdownContent",
  componentId: "sc-1vkom6t-1"
})(["display:flex;flex-direction:column;gap:10px;"]);
const OptionWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "MoreBenefitsstyle__OptionWrapper",
  componentId: "sc-1vkom6t-2"
})(["display:flex;align-items:center;gap:8px;cursor:pointer;"]);
const RadioButtonContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "MoreBenefitsstyle__RadioButtonContainer",
  componentId: "sc-1vkom6t-3"
})(["width:24px;height:24px;display:flex;align-items:center;justify-content:center;"]);
const RadioButtonSelected = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "MoreBenefitsstyle__RadioButtonSelected",
  componentId: "sc-1vkom6t-4"
})(["width:20px;height:20px;border-radius:50%;border:2px solid #008cff;background:white;display:flex;align-items:center;justify-content:center;"]);
const RadioButtonInner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "MoreBenefitsstyle__RadioButtonInner",
  componentId: "sc-1vkom6t-5"
})(["width:10px;height:10px;border-radius:50%;background:#008cff;"]);
const RadioButtonUnselected = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "MoreBenefitsstyle__RadioButtonUnselected",
  componentId: "sc-1vkom6t-6"
})(["width:20px;height:20px;border-radius:50%;border:2px solid #757575;background:transparent;"]);
const OptionText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "MoreBenefitsstyle__OptionText",
  componentId: "sc-1vkom6t-7"
})(["font-weight:700;font-size:14px;line-height:1.2em;color:#000000;white-space:nowrap;"]);
const SeparatorLine = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "MoreBenefitsstyle__SeparatorLine",
  componentId: "sc-1vkom6t-8"
})(["height:1px;background:#d8d8d8;width:100%;"]);
const DownloadButtonContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "MoreBenefitsstyle__DownloadButtonContainer",
  componentId: "sc-1vkom6t-9"
})(["margin-top:16px;"]);
const DownloadButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "MoreBenefitsstyle__DownloadButton",
  componentId: "sc-1vkom6t-10"
})(["width:100%;height:32px;background:linear-gradient( 135deg,rgba(83,178,254,1) 0%,rgba(6,90,243,1) 100% );border:none;border-radius:8px;color:white;font-weight:900;font-size:12px;text-align:center;cursor:pointer;display:flex;align-items:center;justify-content:center;"]); // Enhanced Links Section Styles

const LinksContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "MoreBenefitsstyle__LinksContainer",
  componentId: "sc-1vkom6t-11"
})(["display:flex;flex-direction:row;align-items:center;gap:8px;margin:0 0 16px 0;flex-wrap:wrap;"]);
const LinkContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "MoreBenefitsstyle__LinkContainer",
  componentId: "sc-1vkom6t-12"
})(["position:relative;"]);
const DropdownToggle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "MoreBenefitsstyle__DropdownToggle",
  componentId: "sc-1vkom6t-13"
})(["display:flex;flex-direction:row;align-items:center;gap:2px;cursor:pointer;"]);
const DropdownArrow = styled_components_browser_esm/* default.svg.withConfig */.ZP.svg.withConfig({
  displayName: "MoreBenefitsstyle__DropdownArrow",
  componentId: "sc-1vkom6t-14"
})(["width:16px;height:16px;transform:", ";transition:transform 0.2s ease;"], props => props.isOpen ? "rotate(180deg)" : "rotate(0deg)");
const LinkSeparator = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "MoreBenefitsstyle__LinkSeparator",
  componentId: "sc-1vkom6t-15"
})(["width:1px;height:14px;background:#757575;opacity:0.6;"]);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/InsurancePlans/MoreBenefits/DropdownModal.tsx







const analytics = (0,insurance/* getAnalytics */.I)();

const DropdownModal = ({
  options,
  quoteId,
  onClose,
  csrfToken
}) => {
  const {
    0: selectedOption,
    1: setSelectedOption
  } = (0,react.useState)(() => {
    // Find the last option with defaultSelected: true, or fallback to first option
    let defaultOption = options[0];
    options.forEach(option => {
      if (option.defaultSelected) {
        defaultOption = option;
      }
    });
    return defaultOption?.id || defaultOption?.url || "";
  });

  const handleDownload = async () => {
    if (selectedOption && quoteId) {
      // Find the selected option
      const selectedOptionData = options.find(option => (option.id || option.url) === selectedOption);

      if (selectedOptionData) {
        // Use the option ID as templateType (e.g., "with_price" or "without_price")
        const templateType = selectedOptionData.id || selectedOptionData.templateType || "with_price";
        const itineraryId = new URLSearchParams(window.location.search).get("itineraryId") || "";
        analytics?.trackListingEvents({
          actionType: `policy_downloaded_${templateType === "with_price" ? "with_price" : "without_price"}`
        });
        await (0,utils/* downloadPdfPost */.Gz)(quoteId, templateType, csrfToken, itineraryId);
        onClose();
      }
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(DropdownModalContainer, {
    "data-test-id": "DropdownModal-DropdownModalContainer",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DropdownContent, {
      "data-test-id": "DropdownModal-DropdownContent",
      children: options.map((option, index) => {
        const optionKey = option.id || option.url || `option-${index}`;
        return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(OptionWrapper, {
            onClick: () => setSelectedOption(optionKey),
            "data-test-id": "DropdownModal-OptionWrapper",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(RadioButtonContainer, {
              "data-test-id": "DropdownModal-RadioButtonContainer",
              children: selectedOption === optionKey ? /*#__PURE__*/(0,jsx_runtime.jsx)(RadioButtonSelected, {
                "data-test-id": "DropdownModal-RadioButtonSelected",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(RadioButtonInner, {
                  "data-test-id": "DropdownModal-RadioButtonInner"
                })
              }) : /*#__PURE__*/(0,jsx_runtime.jsx)(RadioButtonUnselected, {
                "data-test-id": "DropdownModal-RadioButtonUnselected"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(OptionText, {
              "data-test-id": "DropdownModal-OptionText",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
                value: option.title,
                "data-test-id": "DropdownModal-FormattedText"
              })
            })]
          }), index < options.length - 1 && /*#__PURE__*/(0,jsx_runtime.jsx)(SeparatorLine, {
            "data-test-id": "DropdownModal-SeparatorLine"
          })]
        }, optionKey);
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(DownloadButtonContainer, {
      "data-test-id": "DropdownModal-DownloadButtonContainer",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(DownloadButton, {
        onClick: handleDownload,
        "data-test-id": "DropdownModal-DownloadButton",
        children: "DOWNLOAD"
      })
    })]
  });
};

/* harmony default export */ const MoreBenefits_DropdownModal = (DropdownModal);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/InsurancePlans/MoreBenefits/EnhancedLinksSection.tsx









const EnhancedLinksSection_analytics = (0,insurance/* getAnalytics */.I)();

const EnhancedLinksSection = ({
  links,
  ctaLink,
  tncLink,
  quoteId,
  csrfToken
}) => {
  const {
    0: openDropdown,
    1: setOpenDropdown
  } = (0,react.useState)(null);
  const dropdownRef = (0,react.useRef)(null); // Close dropdown when clicking outside

  (0,react.useEffect)(() => {
    const handleClickOutside = event => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpenDropdown(null);
      }
    };

    if (openDropdown) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [openDropdown]); // Backward compatibility: if links array doesn't exist but old props do, create fallback

  const effectiveLinks = links || (ctaLink && tncLink ? [{
    id: "tnc",
    title: {
      text: {
        value: ctaLink
      }
    },
    type: "link",
    url: tncLink
  }] : []);
  if (!effectiveLinks.length) return null;

  const handleDropdownToggle = linkId => {
    if (openDropdown === null) {
      EnhancedLinksSection_analytics?.trackListingEvents({
        actionType: `download_benefits_clicked_view_details_modal`
      });
    }

    setOpenDropdown(openDropdown === linkId ? null : linkId);
  };

  const handleLinkClick = url => {
    window.open(url, "_blank");
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(LinksContainer, {
    "data-test-id": "EnhancedLinksSection-LinksContainer",
    children: effectiveLinks.map(link => /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
      children: [link.type === "link" ? /*#__PURE__*/(0,jsx_runtime.jsx)(components.AnchorTag, {
        fontSize: "xs",
        fontWeight: "bold",
        color: Global/* theme.blueText */.rS.blueText,
        hrefProp: link.url,
        targetProp: "_blank",
        handleClick: () => {
          EnhancedLinksSection_analytics?.trackListingEvents({
            actionType: "tnc_link_clicked"
          }, "pageView");
          (0,XDMAnalytics.trackEvent)({
            event_detail: {
              event_type: "action",
              event_name: "component_cta-clicked",
              event_value: "tnc_link_clicked"
            }
          });
        },
        "data-test-id": "EnhancedLinksSection-AnchorTag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
          value: link.title,
          "data-test-id": "EnhancedLinksSection-FormattedText"
        })
      }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(LinkContainer, {
        ref: dropdownRef,
        "data-test-id": "EnhancedLinksSection-LinkContainer",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DropdownToggle, {
          onClick: () => handleDropdownToggle(link.id),
          onKeyDown: e => {
            if (e.key === "Enter" || e.key === " ") {
              handleDropdownToggle(link.id);
            }
          },
          tabIndex: 0,
          "data-test-id": "EnhancedLinksSection-DropdownToggle",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.AnchorTag, {
            fontSize: "xs",
            fontWeight: "bold",
            color: Global/* theme.blueText */.rS.blueText,
            "data-test-id": "EnhancedLinksSection-AnchorTag",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
              value: link.title,
              "data-test-id": "EnhancedLinksSection-FormattedText"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DropdownArrow, {
            isOpen: openDropdown === link.id,
            viewBox: "0 0 16 16",
            fill: "none",
            "data-test-id": "EnhancedLinksSection-DropdownArrow",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
              d: "M4.33 5.73L8 9.73L11.67 5.73",
              stroke: "#0084FF",
              strokeWidth: "1.33",
              strokeLinecap: "round",
              strokeLinejoin: "round"
            })
          })]
        }), openDropdown === link.id && link.dropdownOptions && /*#__PURE__*/(0,jsx_runtime.jsx)(MoreBenefits_DropdownModal, {
          options: link.dropdownOptions,
          quoteId: quoteId,
          onClose: () => setOpenDropdown(null),
          csrfToken: csrfToken,
          "data-test-id": "EnhancedLinksSection-DropdownModal"
        })]
      }), effectiveLinks.indexOf(link) < effectiveLinks.length - 1 && /*#__PURE__*/(0,jsx_runtime.jsx)(LinkSeparator, {
        "data-test-id": "EnhancedLinksSection-LinkSeparator"
      })]
    }, link.id))
  });
};

/* harmony default export */ const MoreBenefits_EnhancedLinksSection = (EnhancedLinksSection);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/InsurancePlans/InsPlanModalCommonInfo.tsx










const InsPlanModalCommonInfo = ({
  data,
  isAddOnBenefits,
  tag
}) => {
  const partner = (0,utils/* getPartnerOnClientSide */.et)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
    children: [data?.packName && /*#__PURE__*/(0,jsx_runtime.jsx)(components.ParaTag, {
      fontSize: "xs",
      fontWeight: "black" // color={data?.packNameColor}
      ,
      margin: "0 0 4px",
      "data-test-id": "InsPlanModalCommonInfo-ParaTag",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
        value: data?.packName,
        "data-test-id": "InsPlanModalCommonInfo-FormattedText"
      })
    }), tag && /*#__PURE__*/(0,jsx_runtime.jsx)(InsurancePlans_style/* TagWrap */.yU, {
      "data-test-id": "InsPlanModalCommonInfo-TagWrap",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
        value: tag,
        "data-test-id": "InsPlanModalCommonInfo-FormattedText"
      })
    }), data.insuranceType && /*#__PURE__*/(0,jsx_runtime.jsxs)(InsurancePlans_style/* VendorWrap */.df, {
      margin: isAddOnBenefits ? "0px 0px 8px 0px" : "0",
      "data-test-id": "InsPlanModalCommonInfo-VendorWrap",
      children: [data?.vendorDisplayIcon && /*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
        src: data?.vendorDisplayIcon,
        height: "34px",
        width: "32px" // margin="0px 0px 4px 0px"
        ,
        "data-test-id": "InsPlanModalCommonInfo-ImageComponent"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.ParaTag, {
        fontSize: isAddOnBenefits ? "md" : "large",
        margin: "0 0 4px",
        color: Global/* theme.blackText */.rS.blackText,
        fontWeight: "black",
        "data-test-id": "InsPlanModalCommonInfo-ParaTag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
          value: data?.insuranceType,
          "data-test-id": "InsPlanModalCommonInfo-FormattedText"
        })
      })]
    }), data.insPlanName && /*#__PURE__*/(0,jsx_runtime.jsx)(components.ParaTag, {
      fontSize: "xs",
      margin: "0 0 4px",
      "data-test-id": "InsPlanModalCommonInfo-ParaTag",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(components.SpanTag, {
        fontSize: "xs",
        color: Global/* theme.greyText7 */.rS.greyText7,
        "data-test-id": "InsPlanModalCommonInfo-SpanTag",
        children: [data?.vendorDisplayPrefix, " ", /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
          value: data?.insPlanName,
          "data-test-id": "InsPlanModalCommonInfo-FormattedText"
        })]
      })
    }), data?.ctaLink && /*#__PURE__*/(0,jsx_runtime.jsx)(components.AnchorTag, {
      fontSize: "xs",
      margin: "0 0 16px",
      hrefProp: data?.tncLink,
      targetProp: "_blank",
      "data-test-id": "InsPlanModalCommonInfo-AnchorTag",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
        value: data?.ctaLink,
        "data-test-id": "InsPlanModalCommonInfo-FormattedText"
      })
    }), partner === src.PARTNER.MYPARTNER && /*#__PURE__*/(0,jsx_runtime.jsx)(MoreBenefits_EnhancedLinksSection, {
      links: data?.links,
      ctaLink: data?.ctaLink,
      tncLink: data?.tncLink,
      quoteId: data?.quoteId,
      csrfToken: data?.csrfToken,
      "data-test-id": "InsPlanModalCommonInfo-EnhancedLinksSection"
    }), data?.planExtraInfo && /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
      fontSize: "xs",
      color: Global/* theme.greyText7 */.rS.greyText7,
      margin: "0 0 14px",
      "data-test-id": "InsPlanModalCommonInfo-SpanTag",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
        value: data?.planExtraInfo,
        "data-test-id": "InsPlanModalCommonInfo-FormattedText"
      })
    }), data?.service && /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
      fontSize: "xs",
      color: Global/* theme.greyText7 */.rS.greyText7,
      margin: "0 0 14px",
      "data-test-id": "InsPlanModalCommonInfo-SpanTag",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
        value: data?.service,
        "data-test-id": "InsPlanModalCommonInfo-FormattedText"
      })
    })]
  });
};

/* harmony default export */ const InsurancePlans_InsPlanModalCommonInfo = (InsPlanModalCommonInfo);

/***/ }),

/***/ 6660:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _tm_static__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48359);
/* harmony import */ var _tm_utility_global__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42874);
/* harmony import */ var _tm_ui_widgets__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87109);
/* harmony import */ var _InsurancePlans_style__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5563);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52322);








const InsurancePlanTypeSectionComp = ({
  data,
  handleMoreBenefits,
  handleTravAssist
}) => {
  const device = (0,_tm_ui_widgets__WEBPACK_IMPORTED_MODULE_3__/* .useBreakpointV2 */ .bU)();
  const {
    expertAssistanceInfo,
    sportsActivity,
    expertAssistanceIcon,
    assistanceCovers,
    insBenefits,
    showSeparator,
    productCta
  } = data;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_InsurancePlans_style__WEBPACK_IMPORTED_MODULE_4__/* .InsurancePlanTypeSection */ .fK, {
    "data-test-id": "InsurancePlanTypeSectionComp-InsurancePlanTypeSection",
    children: [expertAssistanceInfo && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.FlexComp, {
      justifyContent: "space-between",
      margin: "0 0 12px",
      alignItems: "center",
      "data-test-id": "InsurancePlanTypeSectionComp-FlexComp",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.SpanTag, {
        fontSize: "xs",
        fontWeight: "bold",
        color: _tm_utility_global__WEBPACK_IMPORTED_MODULE_2__/* .theme.greenText3 */ .rS.greenText3,
        "data-test-id": "InsurancePlanTypeSectionComp-SpanTag",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.FormattedText, {
          value: expertAssistanceInfo,
          "data-test-id": "InsurancePlanTypeSectionComp-FormattedText"
        })
      }), expertAssistanceIcon && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.ImageComponent, {
        width: device == "lg" ? "30px" : "24px",
        height: device == "lg" ? "30px" : "24px",
        src: expertAssistanceIcon,
        "data-test-id": "InsurancePlanTypeSectionComp-ImageComponent"
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_InsurancePlans_style__WEBPACK_IMPORTED_MODULE_4__/* .PlanSectionItem */ .l2, {
      "data-test-id": "InsurancePlanTypeSectionComp-PlanSectionItem",
      children: [insBenefits && insBenefits.map((item, index) => {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.FlexComp, {
          gap: "0",
          width: device == "lg" ? "max-content" : "100%",
          flexDirection: device == "lg" ? "column" : "row",
          justifyContent: device == "sm" ? "space-between" : "unset",
          "data-test-id": `InsurancePlanTypeSectionComp-FlexComp-${index}`,
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.ParaTag, {
            fontWeight: index == 0 ? "bold" : "regular",
            fontSize: "xs",
            "data-test-id": "InsurancePlanTypeSectionComp-ParaTag",
            children: item.policyTitle
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.SpanTag, {
            fontWeight: index == 0 ? "bold" : "regular",
            fontSize: "xs",
            "data-test-id": "InsurancePlanTypeSectionComp-SpanTag",
            children: item.policyAmt
          })]
        }, index);
      }), assistanceCovers && assistanceCovers.map((item, index) => {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.ParaTag, {
          fontWeight: "bold",
          fontSize: "xs",
          "data-test-id": `InsurancePlanTypeSectionComp-ParaTag-${index}`,
          children: item
        }, index);
      }), !showSeparator && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.AnchorTag, {
        handleClick: insBenefits && handleMoreBenefits ? () => handleMoreBenefits(parseInt(data.productId)) : assistanceCovers && handleTravAssist ? () => handleTravAssist(parseInt(data.productId)) : () => {},
        fontSize: "xs",
        fontWeight: "bold",
        textAlign: device == "lg" ? "right" : "left",
        "data-test-id": "InsurancePlanTypeSectionComp-AnchorTag",
        children: [insBenefits && `${data?.totalBenefits} More Benefits`, assistanceCovers && "View Details"]
      })]
    }), showSeparator && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_InsurancePlans_style__WEBPACK_IMPORTED_MODULE_4__/* .Separator */ .Z0, {
      "data-test-id": "InsurancePlanTypeSectionComp-Separator"
    }), showSeparator && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
      style: {
        textAlign: device == "sm" ? "right" : "left"
      },
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.AnchorTag, {
        fontSize: "xs",
        fontWeight: "bold",
        handleClick: productCta?.url ? () => window.open(productCta?.url, "_blank") : () => {},
        "data-test-id": "InsurancePlanTypeSectionComp-AnchorTag",
        children: productCta?.text
      })
    }), sportsActivity && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_InsurancePlans_style__WEBPACK_IMPORTED_MODULE_4__/* .ActivityStatus */ .fU, {
      "data-test-id": "InsurancePlanTypeSectionComp-ActivityStatus",
      children: [sportsActivity?.icon && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.ImageComponent, {
        width: device == "lg" ? "24px" : "16px",
        height: device == "lg" ? "24px" : "16px",
        src: sportsActivity?.icon,
        "data-test-id": "InsurancePlanTypeSectionComp-ImageComponent"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.SpanTag, {
        fontSize: "xs",
        color: _tm_utility_global__WEBPACK_IMPORTED_MODULE_2__/* .theme.blackText */ .rS.blackText,
        "data-test-id": "InsurancePlanTypeSectionComp-SpanTag",
        children: sportsActivity?.title && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.FormattedText, {
          value: sportsActivity?.title,
          "data-test-id": "InsurancePlanTypeSectionComp-FormattedText"
        })
      })]
    })]
  });
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (InsurancePlanTypeSectionComp);

/***/ }),

/***/ 5563:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Am": () => (/* binding */ AmountWrap),
/* harmony export */   "BO": () => (/* binding */ InsurancePlansStyle),
/* harmony export */   "JY": () => (/* binding */ PopularTag),
/* harmony export */   "NB": () => (/* binding */ InsurancePlanTypeHd),
/* harmony export */   "Ob": () => (/* binding */ BenefitPrice),
/* harmony export */   "Q2": () => (/* binding */ InsurancePlanSection),
/* harmony export */   "T7": () => (/* binding */ EmptyBorder),
/* harmony export */   "Tu": () => (/* binding */ BenefitName),
/* harmony export */   "Z0": () => (/* binding */ Separator),
/* harmony export */   "_L": () => (/* binding */ GreyChevWrap),
/* harmony export */   "_P": () => (/* binding */ TravAssistWraning),
/* harmony export */   "bT": () => (/* binding */ InsuranceTypeSection),
/* harmony export */   "df": () => (/* binding */ VendorWrap),
/* harmony export */   "fK": () => (/* binding */ InsurancePlanTypeSection),
/* harmony export */   "fU": () => (/* binding */ ActivityStatus),
/* harmony export */   "l2": () => (/* binding */ PlanSectionItem),
/* harmony export */   "nA": () => (/* binding */ InsurancePlansCompStyle),
/* harmony export */   "yU": () => (/* binding */ TagWrap),
/* harmony export */   "zQ": () => (/* binding */ PlanHeader)
/* harmony export */ });
/* unused harmony export TravelAssistanceSection */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82740);
/* harmony import */ var _tm_static_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84576);
/* harmony import */ var _TextStyles_TextStyles_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93139);
/* harmony import */ var _CheckButton_CheckButton_style__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10569);
/* harmony import */ var _tm_utility_global__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42874);





const InsurancePlansStyle = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "InsurancePlansstyle__InsurancePlansStyle",
  componentId: "sc-1k7o2k3-0"
})(["background:#ffffff;box-shadow:0px 3px 30px rgba(0,0,0,0.16);border-radius:16px;padding:30px;picture{display:inherit;}@media ", "{padding:24px 16px;border-radius:16px 16px 0 0;}"], _tm_static_utils__WEBPACK_IMPORTED_MODULE_1__/* .deviceType.mobile */ .vO.mobile);
const InsurancePlansCompStyle = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "InsurancePlansstyle__InsurancePlansCompStyle",
  componentId: "sc-1k7o2k3-1"
})(["border:1px solid #e2e2e2;border-radius:8px;overflow:hidden;margin-bottom:24px;"]);
const PlanHeader = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "InsurancePlansstyle__PlanHeader",
  componentId: "sc-1k7o2k3-2"
})(["background:#f6f6f6;border-radius:8px 8px 0px 0px;padding:16px;display:flex;align-items:center;gap:12px;", "{flex-direction:row-reverse;gap:10px;}"], _CheckButton_CheckButton_style__WEBPACK_IMPORTED_MODULE_3__/* .CheckButtonStyle */ .m);
const InsurancePlanSection = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "InsurancePlansstyle__InsurancePlanSection",
  componentId: "sc-1k7o2k3-3"
})(["background:#fff;padding:16px;"]);
const InsuranceTypeSection = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "InsurancePlansstyle__InsuranceTypeSection",
  componentId: "sc-1k7o2k3-4"
})(["display:flex;flex-direction:column;gap:2px;flex-shrink:0;width:54%;@media ", "{flex-shrink:unset;width:80%;}"], _tm_static_utils__WEBPACK_IMPORTED_MODULE_1__/* .deviceType.mobile */ .vO.mobile);
const InsurancePlanTypeHd = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "InsurancePlansstyle__InsurancePlanTypeHd",
  componentId: "sc-1k7o2k3-5"
})(["background:linear-gradient( 0deg,rgba(0,140,255,0.04),rgba(0,140,255,0.04) ),#f6f8ff;border-radius:8px 8px 0px 0px;padding:12px 16px;display:flex;justify-content:space-between;align-items:center;", "{padding-bottom:10px;margin-bottom:-10px;}@media ", "{padding:12px 8px;}"], _TextStyles_TextStyles_style__WEBPACK_IMPORTED_MODULE_2__/* .AnchorTagStyle */ .C2, _tm_static_utils__WEBPACK_IMPORTED_MODULE_1__/* .deviceType.mobile */ .vO.mobile);
const InsurancePlanTypeSection = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "InsurancePlansstyle__InsurancePlanTypeSection",
  componentId: "sc-1k7o2k3-6"
})(["background:linear-gradient( 149.61deg,rgba(239,255,254,0.5) 0.83%,rgba(230,237,255,0.368088) 26.25%,rgba(234,246,255,0.5) 97.19% );border-radius:0 0 8px 8px;padding:12px 16px;"]);
const ActivityStatus = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "InsurancePlansstyle__ActivityStatus",
  componentId: "sc-1k7o2k3-7"
})(["display:flex;align-items:center;gap:8px;padding-top:12px;border-top:1px solid #e2e2e2;margin-top:12px;"]);
const TravelAssistanceSection = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "InsurancePlansstyle__TravelAssistanceSection",
  componentId: "sc-1k7o2k3-8"
})(["background:rgba(228,251,244,0.5);border-radius:4px;padding:8px;margin-top:16px;display:flex;align-items:center;gap:8px;"]);
const PopularTag = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "InsurancePlansstyle__PopularTag",
  componentId: "sc-1k7o2k3-9"
})(["background:linear-gradient(87.29deg,#c86dd7 0%,#3023ae 100%);border-radius:0px 16px 16px 0px;padding:1px 8px 2px;margin-left:-16px;flex-shrink:0;@media ", "{border-radius:16px;margin-left:0;}"], _tm_static_utils__WEBPACK_IMPORTED_MODULE_1__/* .deviceType.mobile */ .vO.mobile);
const AmountWrap = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "InsurancePlansstyle__AmountWrap",
  componentId: "sc-1k7o2k3-10"
})(["display:flex;justify-content:space-between;background:#ffffff;box-shadow:", ";padding:16px 30px;position:sticky;bottom:-20px;margin:auto -30px -20px;@media ", "{padding:8px 20px;}"], p => p.boxShadow ? p.boxShadow : "0px 1px 7px rgba(0, 0, 0, 0.2)", _tm_static_utils__WEBPACK_IMPORTED_MODULE_1__/* .deviceType.mobile */ .vO.mobile);
const EmptyBorder = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "InsurancePlansstyle__EmptyBorder",
  componentId: "sc-1k7o2k3-11"
})(["width:100%;height:1px;background:#e2e2e2;"]);
const GreyChevWrap = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "InsurancePlansstyle__GreyChevWrap",
  componentId: "sc-1k7o2k3-12"
})(["cursor:pointer;flex-shrink:0;transition:0.5s ease-in;transform-origin:center;width:32px;height:32px;display:flex;", ""], p => p.chevOpen ? `
    transform:rotate(180deg);
   
    ` : `
    transform:rotate(0deg);
   
    `);
const BenefitName = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(_TextStyles_TextStyles_style__WEBPACK_IMPORTED_MODULE_2__/* .SpanTagStyle */ .zs).withConfig({
  displayName: "InsurancePlansstyle__BenefitName",
  componentId: "sc-1k7o2k3-13"
})(["flex-shrink:0;text-transform:uppercase;@media ", "{font-size:12px;font-weight:600;color:", ";}"], _tm_static_utils__WEBPACK_IMPORTED_MODULE_1__/* .deviceType.mobile */ .vO.mobile, _tm_utility_global__WEBPACK_IMPORTED_MODULE_4__/* .theme.greyText6 */ .rS.greyText6);
const BenefitPrice = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(_TextStyles_TextStyles_style__WEBPACK_IMPORTED_MODULE_2__/* .SpanTagStyle */ .zs).withConfig({
  displayName: "InsurancePlansstyle__BenefitPrice",
  componentId: "sc-1k7o2k3-14"
})(["flex-shrink:0;"]);
const TravAssistWraning = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "InsurancePlansstyle__TravAssistWraning",
  componentId: "sc-1k7o2k3-15"
})(["background:#ffedd1;border-radius:8px;padding:20px;display:flex;align-items:flex-start;gap:8px;svg{flex-shrink:0;}"]);
const PlanSectionItem = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "InsurancePlansstyle__PlanSectionItem",
  componentId: "sc-1k7o2k3-16"
})(["display:grid;grid-template-columns:1fr 1fr 1fr 0.5fr;gap:30px;", "{width:\"max-content\";}@media ", "{grid-template-columns:repeat(1,1fr);gap:12px;}"], _TextStyles_TextStyles_style__WEBPACK_IMPORTED_MODULE_2__/* .ParaTagStyle */ .OG, _tm_static_utils__WEBPACK_IMPORTED_MODULE_1__/* .deviceType.mobile */ .vO.mobile);
const VendorWrap = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "InsurancePlansstyle__VendorWrap",
  componentId: "sc-1k7o2k3-17"
})(["display:flex;gap:8px;align-items:center;", " img{border-radius:4px;}"], p => p.margin && `margin:${p.margin};`);
const TagWrap = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "InsurancePlansstyle__TagWrap",
  componentId: "sc-1k7o2k3-18"
})(["display:flex;background:linear-gradient(88.44deg,#12714f 0.02%,#1ca099 100.01%);padding:2px 8px 2px 8px;border-radius:16px;height:20px;color:#ffffff;align-items:center;font-size:12px;font-weight:700;width:fit-content;margin:0px 0px 10px 0px;"]);
const Separator = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "InsurancePlansstyle__Separator",
  componentId: "sc-1k7o2k3-19"
})(["height:2px;background-color:#d8d8d8;margin-top:16px;max-width:100%;"]);

/***/ }),

/***/ 16061:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _tm_insurance_analytics__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83636);
/* harmony import */ var _tm_insurance_navigation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(576);
/* harmony import */ var _tm_static__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48359);
/* harmony import */ var _tm_ui__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(76609);
/* harmony import */ var _tm_ui_widgets__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87109);
/* harmony import */ var _tm_utility_global__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(42874);
/* harmony import */ var _tm_insurance_analytics_xdm__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(50354);
/* harmony import */ var _tm_utility_analytics__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(11508);
/* harmony import */ var _InsurancePlans_style__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(5563);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(52322);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }














const analytics = (0,_tm_insurance_analytics__WEBPACK_IMPORTED_MODULE_2__/* .getAnalytics */ .I)();

const InsurancePlans = ({
  data,
  title,
  quickFiltersTitle,
  quickFilters,
  setQuickFilters,
  tagData,
  filterData,
  compareToastData,
  comparePlan
}) => {
  const device = (0,_tm_ui_widgets__WEBPACK_IMPORTED_MODULE_6__/* .useBreakpointV2 */ .bU)();
  const {
    0: planSelected,
    1: setPlanSelected
  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(data);
  const {
    0: count,
    1: setCount
  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
  const {
    0: quoteId1ForCompare,
    1: setQuoteId1ForCompare
  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
  const {
    0: quoteId2ForCompare,
    1: setQuoteId2ForCompare
  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
  const {
    0: productId1ForCompare,
    1: setProductId1ForCompare
  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
  const {
    0: productId2ForCompare,
    1: setProductId2ForCompare
  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
  const {
    0: showFilter,
    1: setShowFilter
  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
  const {
    0: comparePlanText,
    1: setComparePlanText
  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("0/2 Products Selected");
  const {
    0: isDisable,
    1: setIsDisable
  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true);
  const {
    0: showTravAssist,
    1: setshowTravAssist
  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(-1);
  const {
    0: showBenefits,
    1: setShowBenefits
  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(-1);
  const {
    0: showCompareNow,
    1: setShowCompareNow
  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
  const {
    type
  } = (0,_tm_ui__WEBPACK_IMPORTED_MODULE_5__/* .usePlanType */ .U)();
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    if (count === 1) {
      setComparePlanText("1/2 Products Selected");
    } else if (count > 1) {
      setComparePlanText("2/2 Products Selected");
    } else {
      setComparePlanText("0/2 Products Selected");
    }
  }, [count]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    if (count === 2) {
      setIsDisable(false);
    } else {
      setIsDisable(true);
    }
  }, [count]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    if (quickFilters) {
      setPlanSelected(data);
      const selectedFiltersCardIds = quickFilters.filter(filter => filter.isSelected)?.reduce((acc, item) => {
        return [...acc, ...(item.cardIds || item.plans)];
      }, []) ?? [];
      const filteredCards = data?.filter(plan => {
        return selectedFiltersCardIds.includes(plan.id);
      });
      filteredCards?.length && setPlanSelected(filteredCards);
    }
  }, [quickFilters]);

  const handleShowFilter = () => {
    setShowFilter(!showFilter);
  };

  const toggleBenefitsModal = index => {
    showBenefits === index ? setShowBenefits(-1) : setShowBenefits(index);
  };

  const handleTravAssist = index => {
    showTravAssist == index ? setshowTravAssist(-1) : setshowTravAssist(index);
  };

  const handleFilterChange = id => {
    if (quickFilters) {
      const changedFilters = quickFilters.map(item => {
        if (item.id == id) {
          analytics?.trackListingEvents({
            actionType: "sum_insured_selected",
            payload: item.name
          }, "pageView", type);
          const productList = item?.quoteIds?.map(data => {
            return {
              id: data.toString()
            };
          });
          (0,_tm_insurance_analytics_xdm__WEBPACK_IMPORTED_MODULE_8__.trackEvent)({
            event_detail: {
              components: {
                product_list: productList
              },
              event_type: "action",
              event_name: "component_cta-clicked",
              event_value: `sum_insured_selected_${item.name}`
            }
          });
          return _objectSpread(_objectSpread({}, item), {}, {
            isSelected: true
          });
        } else {
          return _objectSpread(_objectSpread({}, item), {}, {
            isSelected: false
          });
        }
      });
      setQuickFilters(changedFilters);
    }
  };

  const handlePlanSelected = productId => {
    const updateCompareState = (item, id, quoteId) => {
      if (!item.selectedForCompare && count === 2) {
        return item;
      } else {
        item.selectedForCompare = !item.selectedForCompare;
      }

      if (item.selectedForCompare) {
        setCount(count + 1);

        if (quoteId1ForCompare == "") {
          setQuoteId1ForCompare(quoteId);
          setProductId1ForCompare(id);
        } else {
          setQuoteId2ForCompare(quoteId);
          setProductId2ForCompare(id);
        }
      } else {
        setCount(count - 1);

        if (quoteId == quoteId1ForCompare) {
          setQuoteId1ForCompare(quoteId2ForCompare);
          setProductId1ForCompare(productId2ForCompare);
        }

        setQuoteId2ForCompare("");
        setProductId2ForCompare("");
      }
    };

    const updatedPlanSelected = planSelected?.map(item => {
      if (item?.cardData && productId === item.id) {
        updateCompareState(item.cardData, item.cardData.productId, item.cardData.quoteId);
      } else if (productId === item.productId) {
        updateCompareState(item, item.productId, item.quoteId);
      }

      return item;
    });
    setPlanSelected(updatedPlanSelected);
  };

  const handleSelectCompare = () => {
    if (!showCompareNow) {
      analytics?.trackListingEvents({
        actionType: "comparenow_opened"
      }, "pageView", type);
      (0,_tm_insurance_analytics_xdm__WEBPACK_IMPORTED_MODULE_8__.trackEvent)({
        event_detail: {
          components: {
            product_list: [{
              id: productId1ForCompare
            }, {
              id: productId2ForCompare
            }]
          },
          event_type: "action",
          event_name: "component_cta-clicked",
          event_value: "comparenow_opened"
        }
      });
    }

    setShowCompareNow(!showCompareNow);
  };

  const buyProduct = (quoteId, productId) => {
    const searchParams = new URLSearchParams(window.location.search);
    const queryParams = Object.fromEntries(searchParams.entries());

    let params = _objectSpread(_objectSpread({}, queryParams), {}, {
      countries: searchParams.get("countries"),
      startDate: searchParams.get("startDate"),
      endDate: searchParams.get("endDate"),
      travellers: searchParams.get("travellers"),
      isUpcomingTrip: searchParams.has("isUpcomingTrip") ? searchParams.get("isUpcomingTrip") : false,
      productId,
      quoteId
    });

    (0,_tm_insurance_analytics_xdm__WEBPACK_IMPORTED_MODULE_8__.triggerPageExit)();
    (0,_tm_utility_analytics__WEBPACK_IMPORTED_MODULE_9__/* .storePageTransitionStart */ .SE)("listing");
    _tm_insurance_navigation__WEBPACK_IMPORTED_MODULE_3__/* .navigationActions.navigateToTravellerDetails */ .ej.navigateToTravellerDetails(params);
  }; // TODO: add logic to compare productId from comparisonIds


  const closeToast = () => {
    setPlanSelected(planSelected?.map(item => {
      item.cardData ? item.cardData.selectedForCompare = false : item.selectedForCompare = false;
      return item;
    }));
    data?.map(item => {
      item.cardData ? item.cardData.selectedForCompare = false : item.selectedForCompare = false;
    });
    setQuoteId1ForCompare("");
    setProductId1ForCompare("");
    return setCount(0);
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)(_InsurancePlans_style__WEBPACK_IMPORTED_MODULE_10__/* .InsurancePlansStyle */ .BO, {
    "data-test-id": "InsurancePlans-InsurancePlansStyle",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_4__.H5Tag, {
      margin: "0 0 16px",
      "data-test-id": "InsurancePlans-H5Tag",
      children: title && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_4__.FormattedText, {
        value: title,
        "data-test-id": "InsurancePlans-FormattedText"
      })
    }), quickFiltersTitle && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_4__.SpanTag, {
      color: _tm_utility_global__WEBPACK_IMPORTED_MODULE_7__/* .theme.greyText */ .rS.greyText,
      fontSize: "sm",
      fontWeight: "black",
      margin: "0 0 8px",
      "data-test-id": "InsurancePlans-SpanTag",
      children: quickFiltersTitle
    }), tagData && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_4__.FlexComp, {
      alignItems: device == "lg" ? "center" : "flex-start",
      justifyContent: "space-between",
      margin: device == "lg" ? "0 0 40px" : "0 0 24px",
      gap: "10px",
      flexDirection: device == "lg" ? "row" : "column",
      "data-test-id": "InsurancePlans-FlexComp",
      children: quickFilters && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_4__.Tags, {
        handleClickTab: handleFilterChange,
        data: quickFilters,
        "data-test-id": "InsurancePlans-Tags"
      })
    }), planSelected?.map((item, index) => {
      const productType = // @ts-ignore
      item?.cardData?.packName?.text?.value?.toLowerCase?.();
      const {
        cardType,
        cardData
      } = item || {};
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [cardType == "BANNER" ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_4__.FlexComp, {
          margin: "0 0 24px",
          "data-test-id": "InsurancePlans-FlexComp",
          children: cardData?.image?.url && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("img", {
            src: cardData?.image?.url,
            width: cardData?.image?.width ? cardData?.image?.width : "100%",
            height: cardData?.image?.height
          })
        }) : cardType == "PLAN" || !cardType ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_4__.InsurancePlansComp, {
          showCompareCheckbox: comparePlan ? true : false,
          data: cardData ? cardData : item,
          handleCompareSelect: () => handlePlanSelected(cardData ? item.id : item?.productId),
          handleMoreBenefits: () => {
            analytics?.trackListingEvents({
              actionType: `View_details_${productType}`
            }, "pageView", type);
            (0,_tm_insurance_analytics_xdm__WEBPACK_IMPORTED_MODULE_8__.trackEvent)({
              event_detail: {
                components: {
                  product_list: [{
                    id: item?.cardData?.productId
                  }]
                },
                event_type: "action",
                event_name: "component_cta-clicked",
                event_value: `View_benefits_clicked_${productType}`
              }
            });
            toggleBenefitsModal(index);
          },
          handleTravAssist: () => {
            handleTravAssist(index);
            analytics?.trackListingEvents({
              actionType: `View_details_${productType}`
            }, "pageView", type);
          },
          handleBuyButton: data => {
            analytics?.trackListingEvents({
              actionType: `buy_now_clicked_outside_${productType}`
            }, "pageView", type);
            (0,_tm_insurance_analytics_xdm__WEBPACK_IMPORTED_MODULE_8__.trackEvent)({
              event_detail: {
                components: {
                  product_list: [{
                    id: data?.productId
                  }]
                },
                event_type: "action",
                event_name: "component_cta-clicked",
                event_value: `buy_now_clicked_outside_${productType}`
              }
            });
            buyProduct(data?.quoteId, data?.productId);
          },
          "data-test-id": `InsurancePlans-InsurancePlansComp-${index}`
        }, index) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.Fragment, {}), showBenefits === index && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_4__.MoreBenefits, {
          handleClose: () => toggleBenefitsModal(index),
          moreBenfitsTitle: item?.cardData ? `${item?.cardData.totalBenefits} Benefits` : `${item?.totalBenefits} Benefits`,
          data: item?.cardData ? item.cardData : item,
          handleBuyButton: data => {
            analytics?.trackListingEvents({
              actionType: `buy_now_clicked_details_${productType}`
            }, "pageView", type);
            (0,_tm_insurance_analytics_xdm__WEBPACK_IMPORTED_MODULE_8__.trackEvent)({
              event_detail: {
                components: {
                  product_list: [{
                    id: data?.productId
                  }]
                },
                event_type: "action",
                event_name: "component_cta-clicked",
                event_value: `buy_now_clicked_details_${productType}`
              }
            });
            buyProduct(item?.cardData ? item?.cardData.quoteId : data?.quoteId, item?.cardData ? item?.cardData.productId : item?.productId);
          },
          "data-test-id": "InsurancePlans-MoreBenefits"
        }), showTravAssist == index && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_4__.TravelAssistanceModal, {
          data: item.cardData ? item.cardData : item,
          handleTravAssist: () => handleTravAssist(index),
          travelAssistTitle: "Travel Assistance" // should come from CB
          ,
          "data-test-id": "InsurancePlans-TravelAssistanceModal"
        })]
      }, item.id);
    }), showFilter && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_4__.FilterPlans, {
      tagData: tagData,
      btnText: "Apply Filter",
      filterData: filterData,
      title: "Filter Plan",
      filterPlanHandleClick: handleShowFilter,
      "data-test-id": "InsurancePlans-FilterPlans"
    }), count > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_4__.ToastCompare, {
      toastCloseIcon: "https://tripmoneycmsimgak.mmtcdn.com/img/cross_grey_rounded_e24cbc15d7.svg",
      toastIcon: "https://tripmoneycmsimgak.mmtcdn.com/img/toast_Icon_4389f5385c.svg",
      planSelectedTxt: comparePlanText,
      toastCtaTxt: compareToastData?.toastCtaTxt,
      handleClickCta: handleSelectCompare,
      handleClose: closeToast,
      isDisable: isDisable,
      "data-test-id": "InsurancePlans-ToastCompare"
    }), showCompareNow && comparePlan && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_4__.ComparePlan, {
      modalTitle: compareToastData?.modalTitle,
      data: comparePlan,
      handleClose: handleSelectCompare,
      handleBuyButton: (quoteId, productId) => {
        analytics?.trackListingEvents({
          actionType: "buy_from_compare"
        }, "pageView", type);
        (0,_tm_insurance_analytics_xdm__WEBPACK_IMPORTED_MODULE_8__.trackEvent)({
          event_detail: {
            components: {
              product_list: [{
                id: productId
              }]
            },
            event_type: "action",
            event_name: "component_cta-clicked",
            event_value: "buy_from_compare"
          }
        });
        buyProduct(quoteId, productId);
      },
      productId1ForCompare: productId1ForCompare,
      quoteId1ForCompare: quoteId1ForCompare,
      productId2ForCompare: productId2ForCompare,
      quoteId2ForCompare: quoteId2ForCompare,
      "data-test-id": "InsurancePlans-ComparePlan"
    })]
  });
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (InsurancePlans);

/***/ }),

/***/ 80549:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _tm_static__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48359);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _tm_insurance_analytics__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83636);
/* harmony import */ var _tm_insurance_analytics_xdm__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50354);
/* harmony import */ var _tm_ui__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76609);
/* harmony import */ var _tm_ui_widgets__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87109);
/* harmony import */ var _tm_utility_global__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(42874);
/* harmony import */ var _InsurancePlans_style__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5563);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(52322);










const analytics = (0,_tm_insurance_analytics__WEBPACK_IMPORTED_MODULE_2__/* .getAnalytics */ .I)();

const InsurancePlansComp = ({
  data,
  handleMoreBenefits,
  handleTravAssist,
  handleCompareSelect,
  handleBuyButton,
  showCompareCheckbox = true
}) => {
  const device = (0,_tm_ui_widgets__WEBPACK_IMPORTED_MODULE_5__/* .useBreakpointV2 */ .bU)();
  const productType = // @ts-ignore
  data?.packName?.text?.value?.toLowerCase?.();
  const {
    type
  } = (0,_tm_ui__WEBPACK_IMPORTED_MODULE_4__/* .usePlanType */ .U)();
  const {
    0: isHovered,
    1: setIsHovered
  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    let planName = undefined;
    const text = data?.insuranceType?.text;

    if (typeof text === "string") {
      planName = text;
    } else if (Array.isArray(text)) {
      planName = text[0]?.value;
    } else if (typeof text === "object" && text !== null) {
      planName = text.value;
    }

    if (!analytics || typeof planName !== "string" || planName.trim() === "") {
      return;
    }

    const element = document.getElementById(`insurance-plan-${data?.productId}`);

    if (!element) {
      return;
    }

    const observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        analytics.trackListingEvents({
          actionType: `${planName}_seen`
        }, "pageView", type);
        (0,_tm_insurance_analytics_xdm__WEBPACK_IMPORTED_MODULE_3__.trackComponentView)({
          name: `${planName}_seen`,
          type: "insurancePlan"
        });
        observer.disconnect();
      }
    }, {
      threshold: 1
    });
    observer.observe(element);
    return () => {
      observer.disconnect();
    };
  }, [data]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)(_InsurancePlans_style__WEBPACK_IMPORTED_MODULE_7__/* .InsurancePlansCompStyle */ .nA, {
    id: `insurance-plan-${data?.productId}`,
    "data-test-id": "InsurancePlansComp-InsurancePlansCompStyle",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.InsurancePlansHeader, {
      handleCompareSelect: handleCompareSelect ? () => handleCompareSelect(parseInt(data?.productId)) : () => {},
      data: data,
      showCompareCheckbox: showCompareCheckbox,
      "data-test-id": "InsurancePlansComp-InsurancePlansHeader"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)(_InsurancePlans_style__WEBPACK_IMPORTED_MODULE_7__/* .InsurancePlanSection */ .Q2, {
      "data-test-id": "InsurancePlansComp-InsurancePlanSection",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.FlexComp, {
        gap: "16px",
        justifyContent: "space-between",
        margin: "0 0 16px",
        "data-test-id": "InsurancePlansComp-FlexComp",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)(_InsurancePlans_style__WEBPACK_IMPORTED_MODULE_7__/* .InsuranceTypeSection */ .bT, {
          "data-test-id": "InsurancePlansComp-InsuranceTypeSection",
          children: [data?.insuranceType && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.ParaTag, {
            fontSize: "md",
            fontWeight: "black",
            "data-test-id": "InsurancePlansComp-ParaTag",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.FormattedText, {
              value: data?.insuranceType,
              "data-test-id": "InsurancePlansComp-FormattedText"
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.FlexComp, {
            gap: "8px",
            alignItems: "center",
            "data-test-id": "InsurancePlansComp-FlexComp",
            children: [data?.popularTag && device == "sm" && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_InsurancePlans_style__WEBPACK_IMPORTED_MODULE_7__/* .PopularTag */ .JY, {
              "data-test-id": "InsurancePlansComp-PopularTag",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.SpanTag, {
                fontSize: "xs",
                fontWeight: "bold",
                color: _tm_utility_global__WEBPACK_IMPORTED_MODULE_6__/* .theme.whiteText */ .rS.whiteText,
                textTransform: "uppercase",
                "data-test-id": "InsurancePlansComp-SpanTag",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.FormattedText, {
                  value: "Popular",
                  "data-test-id": "InsurancePlansComp-FormattedText"
                })
              })
            }), data?.planExtraInfo && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.SpanTag, {
              fontSize: "xs",
              color: _tm_utility_global__WEBPACK_IMPORTED_MODULE_6__/* .theme.greyText */ .rS.greyText,
              "data-test-id": "InsurancePlansComp-SpanTag",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.FormattedText, {
                value: data?.planExtraInfo,
                "data-test-id": "InsurancePlansComp-FormattedText"
              })
            })]
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.FlexComp, {
          margin: "0 0 0 auto",
          gap: "0",
          flexDirection: "column",
          alignItems: "flex-end",
          flexShrink: "0",
          width: device == "lg" ? "16%" : "25%",
          "data-test-id": "InsurancePlansComp-FlexComp",
          children: [data?.discountText && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.SpanTag, {
            fontSize: "xs",
            fontWeight: "bold",
            color: _tm_utility_global__WEBPACK_IMPORTED_MODULE_6__/* .theme.greenText */ .rS.greenText,
            "data-test-id": "InsurancePlansComp-SpanTag",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.FormattedText, {
              value: data?.discountText,
              "data-test-id": "InsurancePlansComp-FormattedText"
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.FlexComp, {
            gap: "2px",
            alignItems: "center",
            "data-test-id": "InsurancePlansComp-FlexComp",
            children: [data?.originalPrice && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.FormattedText, {
              value: data?.originalPrice,
              baseStyle: {
                fontSize: 12,
                fontWeight: "regular",
                color: `${_tm_utility_global__WEBPACK_IMPORTED_MODULE_6__/* .theme.greyText6 */ .rS.greyText6}`,
                textDecoration: "line-through",
                textDecorationThickness: 0.7,
                textAlign: "right",
                whiteSpace: "nowrap"
              },
              "data-test-id": "InsurancePlansComp-FormattedText"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.FormattedText, {
              value: data?.insAmount,
              baseStyle: {
                fontSize: "md",
                fontWeight: "bold",
                color: "#000",
                textAlign: "right"
              },
              "data-test-id": "InsurancePlansComp-FormattedText"
            })]
          }), data?.paxPerDay && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.SpanTag, {
            fontSize: "xs",
            color: _tm_utility_global__WEBPACK_IMPORTED_MODULE_6__/* .theme.greyText */ .rS.greyText,
            "data-test-id": "InsurancePlansComp-SpanTag",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.FormattedText, {
              value: data?.paxPerDay,
              "data-test-id": "InsurancePlansComp-FormattedText"
            })
          }), data?.ctaLink && device == "sm" && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.AnchorTag, {
            color: _tm_utility_global__WEBPACK_IMPORTED_MODULE_6__/* .theme.blueText */ .rS.blueText,
            fontSize: "xs",
            hrefProp: data?.tncLink,
            targetProp: "_blank",
            handleClick: () => {
              (0,_tm_insurance_analytics_xdm__WEBPACK_IMPORTED_MODULE_3__.trackEvent)({
                event_detail: {
                  components: {
                    product_list: [{
                      id: data?.productId
                    }]
                  },
                  event_type: "action",
                  event_name: "component_cta-clicked",
                  event_value: `TnC_clicked_${productType}`
                }
              });
              analytics?.trackListingEvents({
                actionType: `TnC_clicked_${productType}`
              }, "pageView", type);
            },
            "data-test-id": "InsurancePlansComp-AnchorTag",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.FormattedText, {
              value: data?.ctaLink,
              "data-test-id": "InsurancePlansComp-FormattedText"
            })
          })]
        }), data?.buyBtn && device == "lg" && handleBuyButton && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.LandingButton, {
          onClick: () => handleBuyButton(data),
          customWidth: "fit-content",
          customTitle: data?.buyBtn,
          "data-test-id": "InsurancePlansComp-LandingButton"
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)(_InsurancePlans_style__WEBPACK_IMPORTED_MODULE_7__/* .InsurancePlanTypeHd */ .NB, {
        "data-test-id": "InsurancePlansComp-InsurancePlanTypeHd",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.FlexComp, {
          gap: "8px",
          alignItems: "center",
          "data-test-id": "InsurancePlansComp-FlexComp",
          children: [data?.insIcon && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.ImageComponent, {
            width: "24px",
            height: "24px",
            src: data?.insIcon,
            "data-test-id": "InsurancePlansComp-ImageComponent"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.SpanTag, {
            fontSize: "sm",
            fontWeight: "black",
            color: _tm_utility_global__WEBPACK_IMPORTED_MODULE_6__/* .theme.greyText */ .rS.greyText,
            "data-test-id": "InsurancePlansComp-SpanTag",
            children: [data?.insPlanName && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.FormattedText, {
              value: data?.insPlanName,
              "data-test-id": "InsurancePlansComp-FormattedText"
            }), data?.insurerNumber && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.AnchorTag, {
              handleMouseEnter: handleMouseEnter,
              handleMouseLeave: handleMouseLeave,
              fontSize: "sm",
              fontWeight: "black",
              "data-test-id": "InsurancePlansComp-AnchorTag",
              children: [device == "lg" ? "&nbsp;" : "", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.FormattedText, {
                value: data?.insurerNumber,
                "data-test-id": "InsurancePlansComp-FormattedText"
              }), isHovered && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.ToolTipComp, {
                handleMouseEnter: handleMouseEnter,
                handleMouseLeave: handleMouseLeave,
                left: "40%",
                top: "23px",
                toolTipArrow: "top",
                width: "247px",
                "data-test-id": "InsurancePlansComp-ToolTipComp",
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.SpanTag, {
                  fontSize: "sm",
                  color: _tm_utility_global__WEBPACK_IMPORTED_MODULE_6__/* .theme.whiteText */ .rS.whiteText,
                  "data-test-id": "InsurancePlansComp-SpanTag",
                  children: data?.insurerDetails?.insurer && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.FormattedText, {
                    value: data?.insurerDetails?.insurer,
                    "data-test-id": "InsurancePlansComp-FormattedText"
                  })
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("br", {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("br", {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.SpanTag, {
                  fontSize: "sm",
                  color: _tm_utility_global__WEBPACK_IMPORTED_MODULE_6__/* .theme.whiteText */ .rS.whiteText,
                  "data-test-id": "InsurancePlansComp-SpanTag",
                  children: data?.insurerDetails?.details && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.FormattedText, {
                    value: data?.insurerDetails?.details,
                    "data-test-id": "InsurancePlansComp-FormattedText"
                  })
                })]
              })]
            }), isHovered && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.ToolTipComp, {
              handleMouseEnter: handleMouseEnter,
              handleMouseLeave: handleMouseLeave,
              left: "40%",
              top: "23px",
              toolTipArrow: "top",
              width: "247px",
              "data-test-id": "InsurancePlansComp-ToolTipComp",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.SpanTag, {
                fontSize: "sm",
                color: _tm_utility_global__WEBPACK_IMPORTED_MODULE_6__/* .theme.whiteText */ .rS.whiteText,
                "data-test-id": "InsurancePlansComp-SpanTag",
                children: data?.insurerDetails?.insurer && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.FormattedText, {
                  value: data?.insurerDetails?.insurer,
                  "data-test-id": "InsurancePlansComp-FormattedText"
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("br", {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("br", {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.SpanTag, {
                fontSize: "sm",
                color: _tm_utility_global__WEBPACK_IMPORTED_MODULE_6__/* .theme.whiteText */ .rS.whiteText,
                "data-test-id": "InsurancePlansComp-SpanTag",
                children: data?.insurerDetails?.details && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.FormattedText, {
                  value: data?.insurerDetails?.details,
                  "data-test-id": "InsurancePlansComp-FormattedText"
                })
              })]
            })]
          })]
        }), data?.ctaLink && device == "lg" && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.AnchorTag, {
          color: _tm_utility_global__WEBPACK_IMPORTED_MODULE_6__/* .theme.blueText */ .rS.blueText,
          fontSize: "xs",
          fontWeight: "black",
          hrefProp: data?.tncLink,
          targetProp: "_blank",
          handleClick: () => {
            analytics?.trackListingEvents({
              actionType: `TnC_clicked_${productType}`
            }, "pageView", type);
            (0,_tm_insurance_analytics_xdm__WEBPACK_IMPORTED_MODULE_3__.trackEvent)({
              event_detail: {
                components: {
                  product_list: [{
                    id: data?.productId
                  }]
                },
                event_type: "action",
                event_name: "component_cta-clicked",
                event_value: `TnC_clicked_${productType}`
              }
            });
          },
          "data-test-id": "InsurancePlansComp-AnchorTag",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.FormattedText, {
            value: data?.ctaLink,
            "data-test-id": "InsurancePlansComp-FormattedText"
          })
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.InsurancePlanTypeSectionComp, {
        data: data,
        handleMoreBenefits: handleMoreBenefits,
        handleTravAssist: handleTravAssist,
        "data-test-id": "InsurancePlansComp-InsurancePlanTypeSectionComp"
      }), data?.buyBtn && device == "sm" && handleBuyButton && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.LandingButton, {
        onClick: () => handleBuyButton(data),
        customWidth: "100%",
        customTitle: data?.buyBtn,
        margin: "16px 0 0",
        "data-test-id": "InsurancePlansComp-LandingButton"
      })]
    })]
  });
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (InsurancePlansComp);

/***/ }),

/***/ 68466:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _tm_static__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48359);
/* harmony import */ var _tm_ui_widgets__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87109);
/* harmony import */ var _tm_utility_global__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42874);
/* harmony import */ var _InsurancePlans_style__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5563);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52322);







const InsurancePlansHeader = ({
  data,
  handleCompareSelect,
  showCompareCheckbox
}) => {
  const device = (0,_tm_ui_widgets__WEBPACK_IMPORTED_MODULE_1__/* .useBreakpointV2 */ .bU)();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(_InsurancePlans_style__WEBPACK_IMPORTED_MODULE_3__/* .PlanHeader */ .zQ, {
    "data-test-id": "InsurancePlansHeader-PlanHeader",
    children: [data?.popularTag && device == "lg" && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_InsurancePlans_style__WEBPACK_IMPORTED_MODULE_3__/* .PopularTag */ .JY, {
      "data-test-id": "InsurancePlansHeader-PopularTag",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.SpanTag, {
        fontSize: "xs",
        fontWeight: "bold",
        color: _tm_utility_global__WEBPACK_IMPORTED_MODULE_2__/* .theme.whiteText */ .rS.whiteText,
        textTransform: "uppercase",
        "data-test-id": "InsurancePlansHeader-SpanTag",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.FormattedText, {
          value: data?.popularTag,
          "data-test-id": "InsurancePlansHeader-FormattedText"
        })
      })
    }), data?.packName && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.SpanTag, {
      fontSize: device == "lg" ? "sm" : "xs",
      fontWeight: "bold",
      textTransform: "uppercase",
      "data-test-id": "InsurancePlansHeader-SpanTag",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.FormattedText, {
        value: data?.packName,
        "data-test-id": "InsurancePlansHeader-FormattedText"
      })
    }), data?.comparePlans && showCompareCheckbox && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.CheckButton, {
      inputIndex: data?.productId,
      inputId: data?.productId,
      handleChange: handleCompareSelect ? () => handleCompareSelect(parseInt(data?.productId)) : () => {},
      isChecked: data?.selectedForCompare,
      margin: "0 0 0 auto",
      "data-test-id": "InsurancePlansHeader-CheckButton",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.SpanTag, {
        fontSize: "sm",
        color: _tm_utility_global__WEBPACK_IMPORTED_MODULE_2__/* .theme.greyText */ .rS.greyText,
        "data-test-id": "InsurancePlansHeader-SpanTag",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.FormattedText, {
          value: data?.comparePlans,
          "data-test-id": "InsurancePlansHeader-FormattedText"
        })
      })
    })]
  });
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (InsurancePlansHeader);

/***/ }),

/***/ 32265:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* reexport */ MoreBenefits_MoreBenefits)
});

// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/OmnitureAnalytics/insurance/index.ts + 5 modules
var insurance = __webpack_require__(83636);
// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/XDMAnalytics/index.ts
var XDMAnalytics = __webpack_require__(50354);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/index.tsx + 12 modules
var components = __webpack_require__(48359);
// EXTERNAL MODULE: ../../libs/ui/src/index.ts
var src = __webpack_require__(76609);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/index.ts + 2 modules
var ui_widgets_src = __webpack_require__(87109);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/InsurancePlans/InsurancePlans.style.ts
var InsurancePlans_style = __webpack_require__(5563);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/InsurancePlans/MoreBenefits/MoreBenefits.tsx










const analytics = (0,insurance/* getAnalytics */.I)();

const MoreBenefits = ({
  moreBenfitsTitle,
  data,
  tag,
  handleClose,
  handleBuyButton,
  isAddOnBenefits,
  customBtnTitle
}) => {
  const device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  const {
    type
  } = (0,src/* usePlanType */.U)();
  (0,react.useEffect)(() => {
    const productType = // @ts-ignore
    data?.packName?.text?.value?.toLowerCase?.();
    analytics?.trackListingEvents( // @ts-ignore
    {
      actionType: `details_pop_shown_${productType}`
    }, "pageView", type);
    (0,XDMAnalytics.trackEvent)({
      event_detail: {
        components: {
          product_list: [{
            id: data?.productId
          }]
        },
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: `details_pop_shown_${productType}`
      }
    });
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(components.CommonModalDweb, {
    handleClick: handleClose,
    customTitle: moreBenfitsTitle,
    "data-test-id": "MoreBenefits-CommonModalDweb",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.InsPlanModalCommonInfo, {
      data: data,
      isAddOnBenefits: isAddOnBenefits,
      tag: tag,
      "data-test-id": "MoreBenefits-InsPlanModalCommonInfo"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.FlexComp, {
      flexDirection: "column",
      gap: "24px",
      margin: "0 0 20px",
      "data-test-id": "MoreBenefits-FlexComp",
      children: data?.moreBenefits && Object.keys(data.moreBenefits)?.map((item, index) => {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(components.BenefitItem, {
          isAddOnBenefits: isAddOnBenefits,
          data: data.moreBenefits?.[item],
          benefitName: item,
          "data-test-id": "MoreBenefits-BenefitItem"
        }, `${index}`);
      })
    }), isAddOnBenefits && /*#__PURE__*/(0,jsx_runtime.jsx)(InsurancePlans_style/* AmountWrap */.Am, {
      boxShadow: "0",
      "data-test-id": "MoreBenefits-AmountWrap",
      children: data?.buyBtn && /*#__PURE__*/(0,jsx_runtime.jsx)(components.LandingButton, {
        customWidth: "-webkit-fill-available",
        customTitle: customBtnTitle,
        onClick: () => handleBuyButton?.(data),
        "data-test-id": "MoreBenefits-LandingButton"
      })
    }), data?.insAmount && /*#__PURE__*/(0,jsx_runtime.jsxs)(InsurancePlans_style/* AmountWrap */.Am, {
      "data-test-id": "MoreBenefits-AmountWrap",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components.FlexComp, {
        gap: "0",
        flexDirection: "column",
        "data-test-id": "MoreBenefits-FlexComp",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
          fontSize: "md",
          fontWeight: "bold",
          color: Global/* theme.blackText */.rS.blackText,
          "data-test-id": "MoreBenefits-SpanTag",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
            value: data?.insAmount,
            "data-test-id": "MoreBenefits-FormattedText"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
          fontSize: "xs",
          color: Global/* theme.greyText */.rS.greyText,
          "data-test-id": "MoreBenefits-SpanTag",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
            value: data?.paxPerDay,
            "data-test-id": "MoreBenefits-FormattedText"
          })
        })]
      }), data?.buyBtn && /*#__PURE__*/(0,jsx_runtime.jsx)(components.LandingButton, {
        customWidth: device == "sm" ? "158px" : "unset",
        customTitle: data.buyBtn,
        onClick: () => handleBuyButton?.(data),
        "data-test-id": "MoreBenefits-LandingButton"
      })]
    })]
  });
};

/* harmony default export */ const MoreBenefits_MoreBenefits = (MoreBenefits);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/InsurancePlans/MoreBenefits/index.ts


/***/ }),

/***/ 18698:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _InsurancePlans_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5563);
/* harmony import */ var _tm_utility_global__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42874);
/* harmony import */ var _tm_static__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48359);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52322);







const TravelAssistanceModal = ({
  travelAssistTitle,
  data,
  handleTravAssist
}) => {
  const travelAssistanceCover = () => {
    for (let i in data?.travelAssistanceCovers) {
      return data?.travelAssistanceCovers?.[i]?.map((item, index) => {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(_tm_static__WEBPACK_IMPORTED_MODULE_3__.FlexComp, {
          alignItems: "flex-start",
          margin: "0 0 20px",
          gap: "20px",
          "data-test-id": `TravelAssistanceModal-travelAssistanceCover-FlexComp-${index}`,
          children: [item.icon && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_3__.ImageComponent, {
            src: item.icon,
            "data-test-id": "TravelAssistanceModal-travelAssistanceCover-ImageComponent"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_3__.ParaTag, {
              margin: "0 0 8px",
              fontSize: "sm",
              fontWeight: "bold",
              "data-test-id": "TravelAssistanceModal-travelAssistanceCover-ParaTag",
              children: item.title && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_3__.FormattedText, {
                value: item.title,
                "data-test-id": "TravelAssistanceModal-travelAssistanceCover-FormattedText"
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_3__.ParaTag, {
              fontSize: "xs",
              color: _tm_utility_global__WEBPACK_IMPORTED_MODULE_2__/* .theme.greyText7 */ .rS.greyText7,
              "data-test-id": "TravelAssistanceModal-travelAssistanceCover-ParaTag",
              children: item.info && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_3__.FormattedText, {
                value: item.info,
                "data-test-id": "TravelAssistanceModal-travelAssistanceCover-FormattedText"
              })
            })]
          })]
        }, index);
      });
    }

    return;
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(_tm_static__WEBPACK_IMPORTED_MODULE_3__.CommonModalDweb, {
    handleClick: handleTravAssist ? () => handleTravAssist(parseInt(data?.productId) ?? 0) : () => {},
    customTitle: travelAssistTitle,
    "data-test-id": "TravelAssistanceModal-CommonModalDweb",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_3__.InsPlanModalCommonInfo, {
      data: data,
      "data-test-id": "TravelAssistanceModal-InsPlanModalCommonInfo"
    }), travelAssistanceCover(), data?.travelAssistanceWarning && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(_InsurancePlans_style__WEBPACK_IMPORTED_MODULE_1__/* .TravAssistWraning */ ._P, {
      "data-test-id": "TravelAssistanceModal-TravAssistWraning",
      children: [data.travelAssistanceWarning.icon && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_3__.ImageComponent, {
        src: data.travelAssistanceWarning.icon,
        "data-test-id": "TravelAssistanceModal-ImageComponent"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
        children: [data.travelAssistanceWarning.title && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_3__.ParaTag, {
          margin: "0 0 8px",
          fontSize: "large",
          fontWeight: "bold",
          color: _tm_utility_global__WEBPACK_IMPORTED_MODULE_2__/* .theme.yellowText */ .rS.yellowText,
          "data-test-id": "TravelAssistanceModal-ParaTag",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_3__.FormattedText, {
            value: data.travelAssistanceWarning.title,
            "data-test-id": "TravelAssistanceModal-FormattedText"
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_3__.ParaTag, {
          color: _tm_utility_global__WEBPACK_IMPORTED_MODULE_2__/* .theme.greyText */ .rS.greyText,
          fontSize: "md",
          "data-test-id": "TravelAssistanceModal-ParaTag",
          children: data?.travelAssistanceWarning.info && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_3__.FormattedText, {
            value: data?.travelAssistanceWarning.info,
            "data-test-id": "TravelAssistanceModal-FormattedText"
          })
        })]
      })]
    })]
  });
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (TravelAssistanceModal);

/***/ }),

/***/ 89578:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ InsuranceStats_InsuranceStats)
});

// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/OmnitureAnalytics/insurance/index.ts + 5 modules
var insurance = __webpack_require__(83636);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/index.tsx + 12 modules
var components = __webpack_require__(48359);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/index.ts + 2 modules
var src = __webpack_require__(87109);
// EXTERNAL MODULE: ../../libs/ui/src/lib/hooks/index.ts + 1 modules
var hooks = __webpack_require__(89565);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/isomorphic-utils/src/index.ts + 7 modules
var isomorphic_utils_src = __webpack_require__(44928);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/utils/index.tsx
var utils = __webpack_require__(84576);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/InsuranceStats/InsuranceStats.style.ts



const InsuranceStatsWrap = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "InsuranceStatsstyle__InsuranceStatsWrap",
  componentId: "mtxv9q-0"
})(["width:100%;@media ", "{padding:0 16px;}"], utils/* deviceType.mobile */.vO.mobile);
const InsuranceStatsStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InsuranceStatsstyle__InsuranceStatsStyle",
  componentId: "mtxv9q-1"
})(["background:#fff;border-radius:16px;padding:40px 80px;display:flex;gap:114px;width:1200px;margin:0 auto;position:relative;z-index:1;display:grid;grid-template-columns:repeat(4,1fr);box-shadow:0px 3px 30px rgba(0,0,0,0.1);", " @media ", "{width:100%;gap:24px;padding:16px;grid-template-columns:repeat(2,1fr);box-shadow:none;", "}"], p => p.theme.pageTheme === isomorphic_utils_src.PARTNER.GI && `
    border-radius: 20px;
    background: #FFF;
    `, utils/* deviceType.mobile */.vO.mobile, p => p.theme.pageTheme === isomorphic_utils_src.PARTNER.GI && `
    background: #fff;
    box-shadow:none;
    `);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/InsuranceStats/InsuranceStats.tsx









const InsuranceStats = ({
  data
}) => {
  const device = (0,src/* useBreakpointV2 */.bU)();
  const analytics = (0,insurance/* getAnalytics */.I)();
  const hasTracked = (0,react.useRef)(false); // Track component view when it comes into viewport

  const handleIntersection = (0,react.useCallback)(data => {
    if (!hasTracked.current) {
      analytics?.trackLandingEvents({
        actionType: "insurance_stats_seen"
      });
    }

    hasTracked.current = true;
  }, []);
  const {
    ref: statsRef
  } = (0,hooks/* useIntersectionObserver */.S)(handleIntersection, {
    threshold: 0.5,
    // Trigger when 50% of component is visible
    triggerOnLeaveViewport: true
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)(InsuranceStatsWrap, {
    ref: statsRef,
    id: "insurance-stats",
    "data-test-id": "InsuranceStats-InsuranceStatsWrap",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(InsuranceStatsStyle, {
      "data-test-id": "InsuranceStats-InsuranceStatsStyle",
      children: data && data.map((item, index) => {
        return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          "data-test-id": `InsuranceStats-${index}`,
          children: [device == "lg" ? /*#__PURE__*/(0,jsx_runtime.jsx)(components.H4Tag, {
            margin: "0 0 4px",
            "data-test-id": "InsuranceStats-H4Tag",
            children: item.title
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)(components.H5Tag, {
            margin: "0 0 4px",
            "data-test-id": "InsuranceStats-H5Tag",
            children: item.title
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.ParaTag, {
            fontSize: device == "lg" ? "md" : "xs",
            "data-test-id": "InsuranceStats-ParaTag",
            children: item.info
          })]
        }, index);
      })
    })
  });
};

/* harmony default export */ const InsuranceStats_InsuranceStats = (InsuranceStats);

/***/ }),

/***/ 39275:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ ItineraryInfoComp_ItineraryInfoComp)
});

// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/OmnitureAnalytics/insurance/index.ts + 5 modules
var insurance = __webpack_require__(83636);
// EXTERNAL MODULE: ../../libs/utility/src/lib/insurance/navigation/index.ts + 5 modules
var navigation = __webpack_require__(576);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/FlexComp/FlexComp.tsx
var FlexComp = __webpack_require__(636);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/FormattedText/FormattedText.tsx
var FormattedText = __webpack_require__(17871);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/ImageComponent/ImageComponent.tsx
var ImageComponent = __webpack_require__(48608);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/TextStyles/AnchorTag.tsx
var AnchorTag = __webpack_require__(38985);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ItineraryInfoComp/ItineraryInfoComp.styles.ts

const ItineraryContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ItineraryInfoCompstyles__ItineraryContainer",
  componentId: "sc-50hicy-0"
})(["background:white;border-radius:16px;padding:16px 24px;margin-bottom:20px;"]);
const Separator = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ItineraryInfoCompstyles__Separator",
  componentId: "sc-50hicy-1"
})(["width:1px;height:20px;background-color:#d1d5db;flex-shrink:0;"]);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ItineraryInfoComp/ItineraryInfoComp.tsx











const formatDate = timestamp => {
  const date = new Date(timestamp * 1000);
  const day = date.getDate();
  const month = date.toLocaleDateString("en-US", {
    month: "short"
  });
  const year = date.getFullYear().toString().slice(-2);
  return `${day} ${month}' ${year}`;
};

const ItineraryInfoComp = ({
  travelDetails
}) => {
  const {
    countries,
    travelDates,
    travellerCount
  } = travelDetails;
  const analytics = (0,insurance/* getAnalytics */.I)();
  const startDateFormatted = formatDate(travelDates?.startDate || new Date().getTime());
  const endDateFormatted = formatDate(travelDates?.endDate || new Date().getTime());
  const travellerText = travellerCount === 1 ? "Traveller" : "Travellers";

  const handleEditClick = () => {
    if (document.referrer) {
      navigation/* navigationActions.goBack */.ej.goBack();
    }

    analytics?.trackListingEvents({
      actionType: "edit_clicked"
    });
    const queryParams = new URLSearchParams(window.location.search);
    const params = {
      countries: queryParams.get("countries"),
      startDate: queryParams.get("startDate"),
      endDate: queryParams.get("endDate"),
      travellers: queryParams.get("travellers"),
      segment: queryParams.get("segment"),
      type: queryParams.get("type") || "",
      itineraryId: queryParams.get("itineraryId") || ""
    };
    navigation/* navigationActions.navigateToLanding */.ej.navigateToLanding(params, false);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(ItineraryContainer, {
    "data-test-id": "ItineraryInfoComp-ItineraryContainer",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(FlexComp/* default */.Z, {
      justifyContent: "space-between",
      "data-test-id": "ItineraryInfoComp-FlexComp",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(FlexComp/* default */.Z, {
        gap: "16px",
        alignItems: "center",
        "data-test-id": "ItineraryInfoComp-FlexComp",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
          value: countries,
          baseStyle: {
            fontWeight: 700,
            fontSize: "18px",
            color: Global/* theme.blackText */.rS.blackText
          },
          "data-test-id": "ItineraryInfoComp-FormattedText"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Separator, {
          "data-test-id": "ItineraryInfoComp-Separator"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
          value: `${startDateFormatted} -To- ${endDateFormatted}`,
          baseStyle: {
            fontWeight: 400,
            fontSize: "16px",
            color: Global/* theme.greyText */.rS.greyText
          },
          "data-test-id": "ItineraryInfoComp-FormattedText"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Separator, {
          "data-test-id": "ItineraryInfoComp-Separator"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
          value: `${travellerCount} ${travellerText}`,
          baseStyle: {
            fontWeight: 400,
            fontSize: "16px",
            color: Global/* theme.greyText */.rS.greyText
          },
          "data-test-id": "ItineraryInfoComp-FormattedText"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(AnchorTag/* default */.Z, {
        handleClick: handleEditClick,
        "data-test-id": "ItineraryInfoComp-AnchorTag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent/* ImageComponent */.c, {
          width: "25px",
          height: "25px",
          src: "https://tripmoneycmsimgak.mmtcdn.com/img/edit_Icon_be6c24806a.svg",
          "data-test-id": "ItineraryInfoComp-ImageComponent"
        })
      })]
    })
  });
};

/* harmony default export */ const ItineraryInfoComp_ItineraryInfoComp = (ItineraryInfoComp);

/***/ }),

/***/ 21537:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ LandingBenefits_LandingBenefits)
});

// EXTERNAL MODULE: ../../libs/ui/src/lib/static/constants/localData.ts
var localData = __webpack_require__(3345);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/LandingBenefits/LandingBenefits.style.ts

const LandingBenefitsContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingBenefitsstyle__LandingBenefitsContainer",
  componentId: "sc-1tptbx8-0"
})(["display:flex;flex-direction:row;align-items:center;justify-content:center;background:linear-gradient( 100.19deg,#f3ecff 6.96%,#ffffff 19.76%,#f3ecff 96.27% );padding:8px 10px;border-radius:12px;"]);
const BenefitItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingBenefitsstyle__BenefitItem",
  componentId: "sc-1tptbx8-1"
})(["display:flex;flex-direction:row;align-items:center;justify-content:center;padding:8px 12px;gap:8px;"]);
const BenefitIcon = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "LandingBenefitsstyle__BenefitIcon",
  componentId: "sc-1tptbx8-2"
})(["width:20px;height:20px;"]);
const BenefitContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingBenefitsstyle__BenefitContent",
  componentId: "sc-1tptbx8-3"
})(["display:flex;flex-direction:column;"]);
const BenefitTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingBenefitsstyle__BenefitTitle",
  componentId: "sc-1tptbx8-4"
})(["font-size:12px;font-weight:700;"]);
const BenefitSubtitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingBenefitsstyle__BenefitSubtitle",
  componentId: "sc-1tptbx8-5"
})(["font-size:12px;font-weight:400;color:grey;"]);
const BenefitSeparator = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingBenefitsstyle__BenefitSeparator",
  componentId: "sc-1tptbx8-6"
})(["width:1px;height:20px;border-left:1px solid #ece2ff;"]);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/LandingBenefits/LandingBenefits.tsx






const LandingBenefits = ({
  benefitsDataList
}) => {
  const benefitsData = benefitsDataList || localData/* LOCAL_LANDING_BENEFITS */.Ml;
  if (!benefitsData) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(LandingBenefitsContainer, {
    "data-test-id": "LandingBenefits-LandingBenefitsContainer",
    children: benefitsData.map((item, index) => /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(BenefitItem, {
        "data-test-id": `LandingBenefits-BenefitItem-${index}`,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BenefitIcon, {
          src: item.icon,
          alt: item.title,
          "data-test-id": "LandingBenefits-BenefitIcon"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BenefitContent, {
          "data-test-id": "LandingBenefits-BenefitContent",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(BenefitTitle, {
            "data-test-id": "LandingBenefits-BenefitTitle",
            children: item.title
          })
        })]
      }, index), index !== benefitsData.length - 1 && /*#__PURE__*/(0,jsx_runtime.jsx)(BenefitSeparator, {
        "data-test-id": "LandingBenefits-BenefitSeparator"
      })]
    }))
  });
};

/* harmony default export */ const LandingBenefits_LandingBenefits = (LandingBenefits);

/***/ }),

/***/ 45590:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "aA": () => (/* binding */ LandingButtonWhiteStyle),
/* harmony export */   "mS": () => (/* binding */ LandingButtonTertiaryStyle),
/* harmony export */   "vj": () => (/* binding */ ShimmerWrap),
/* harmony export */   "zm": () => (/* binding */ LandingButtonStyle)
/* harmony export */ });
/* unused harmony export LandingButtonBlackOutlineStyle */
/* harmony import */ var _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44928);
/* harmony import */ var _tm_utility_global__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42874);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82740);



const LandingButtonStyle = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].button.withConfig */ .ZP.button.withConfig({
  displayName: "LandingButtonstyle__LandingButtonStyle",
  componentId: "sc-1ldh0sr-0"
})(["background-image:", ";border-radius:8px;box-shadow:0px 1px 7px rgba(0,0,0,0.21);color:#fff;width:", ";height:", ";border:none;outline:none;cursor:pointer;margin:", ";flex:", ";flex-shrink:", ";display:flex;align-items:center;gap:8px;justify-content:center;position:relative;padding:12px 20px;text-transform:uppercase;", " ", " span{font-size:", ";font-weight:900;flex-shrink:0;color:#fff;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;max-width:100%;}"], p => p.theme.pageTheme === _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__.PARTNER.MYBIZ ? _tm_utility_global__WEBPACK_IMPORTED_MODULE_1__/* .theme.myBizGradient */ .rS.myBizGradient : _tm_utility_global__WEBPACK_IMPORTED_MODULE_1__/* .theme.blueGradient */ .rS.blueGradient, p => p.customWidth ? p.customWidth : "fit-content", p => p.customHeight ? p.customHeight : "fit-content", p => p.margin ? p.margin : "", p => p.flex ? p.flex : "unset", p => p.flexShrink ? p.flexShrink : "0", p => p.btnTheme === _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__.PARTNER.MMT ? `
    border-radius:8px;
    ` : p.btnTheme === _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__.PARTNER.GI ? `border-radius: 4px;
    background: ${_tm_utility_global__WEBPACK_IMPORTED_MODULE_1__/* .theme.orange */ .rS.orange};
    box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.14);` : "", props => props.disableState && `
  background: ${_tm_utility_global__WEBPACK_IMPORTED_MODULE_1__/* .theme.greyText2 */ .rS.greyText2};
  color: rgba(0, 0, 0, 0.3);
  pointer-events:none;
  `, p => p.fontSize ? p.fontSize : "16px");
const ShimmerWrap = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "LandingButtonstyle__ShimmerWrap",
  componentId: "sc-1ldh0sr-1"
})(["position:absolute;width:68px;height:48px;z-index:12;top:-43px;animation:shimmmer 2.9s ease-in;animation-iteration-count:infinite;animation-fill-mode:backwards;@keyframes shimmmer{0%{transform:translateX(-311px);}100%{transform:translateX(311px);}}"]);
const LandingButtonWhiteStyle = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(LandingButtonStyle).withConfig({
  displayName: "LandingButtonstyle__LandingButtonWhiteStyle",
  componentId: "sc-1ldh0sr-2"
})(["background:", ";box-shadow:0px 1px 7px rgba(0,0,0,0.2);color:var(--tm-accent-color);span{color:var(--tm-accent-color);font-size:", ";letter-spacing:", ";font-weight:700;}", ""], _tm_utility_global__WEBPACK_IMPORTED_MODULE_1__/* .theme.whiteText */ .rS.whiteText, p => p.fontSize ? p.fontSize : "16px", p => p.letterSpacing ? p.letterSpacing : "normal", props => props.disableState && `
background: ${_tm_utility_global__WEBPACK_IMPORTED_MODULE_1__/* .theme.greyText2 */ .rS.greyText2};
color: rgba(0, 0, 0, 0.3);
pointer-events:none;
opacity: 0.7;
`);
const LandingButtonTertiaryStyle = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(LandingButtonStyle).withConfig({
  displayName: "LandingButtonstyle__LandingButtonTertiaryStyle",
  componentId: "sc-1ldh0sr-3"
})(["background:", ";box-shadow:0px 1px 7px rgba(0,0,0,0.2);border:1px solid var(--tm-accent-color);height:32px;padding:9px;color:var(--tm-accent-color);span{color:var(--tm-accent-color);font-size:12px;font-weight:700;}", ""], _tm_utility_global__WEBPACK_IMPORTED_MODULE_1__/* .theme.whiteText */ .rS.whiteText, props => props.disableState && `
background: ${_tm_utility_global__WEBPACK_IMPORTED_MODULE_1__/* .theme.greyText2 */ .rS.greyText2};
color: rgba(0, 0, 0, 0.3);
pointer-events:none;
opacity: 0.7;
`);
const LandingButtonBlackOutlineStyle = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(LandingButtonStyle).withConfig({
  displayName: "LandingButtonstyle__LandingButtonBlackOutlineStyle",
  componentId: "sc-1ldh0sr-4"
})(["background:", ";box-shadow:0px 1px 7px rgba(0,0,0,0.2);border-radius:4px;color:", ";border:1px solid black;span{color:", ";}"], _tm_utility_global__WEBPACK_IMPORTED_MODULE_1__/* .theme.whiteText */ .rS.whiteText, _tm_utility_global__WEBPACK_IMPORTED_MODULE_1__/* .theme.blackText */ .rS.blackText, _tm_utility_global__WEBPACK_IMPORTED_MODULE_1__/* .theme.blackText */ .rS.blackText);

/***/ }),

/***/ 99660:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _tm_static__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48359);
/* harmony import */ var _tm_static_partnerContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58524);
/* harmony import */ var _tm_utility_global__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42874);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2784);
/* harmony import */ var _LandingButton_style__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45590);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52322);








const LandingButton = ({
  customTitle,
  margin,
  customWidth,
  disableState,
  onClick,
  flexShrink,
  shimmerBtn,
  flex,
  customHeight,
  btnLeftIcon,
  btnRightIcon,
  fontSize,
  isLoading,
  buttonref,
  letterSpacing
}) => {
  const context = (0,_tm_static_partnerContext__WEBPACK_IMPORTED_MODULE_1__/* .usePartnerContext */ .X)();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_LandingButton_style__WEBPACK_IMPORTED_MODULE_4__/* .LandingButtonStyle */ .zm, {
    ref: buttonref,
    onClick: onClick,
    customWidth: customWidth,
    margin: margin,
    customHeight: customHeight,
    flexShrink: flexShrink,
    flex: flex,
    fontSize: fontSize,
    letterSpacing: letterSpacing,
    disableState: disableState,
    btnTheme: context ? context : undefined,
    txtClipIcon: btnLeftIcon !== "" && btnRightIcon !== "",
    "data-test-id": "LandingButton-LandingButtonStyle",
    children: isLoading ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.Spinner, {
      spinnerColor: "#fff",
      "data-test-id": "LandingButton-Spinner"
    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(react__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
      children: [btnLeftIcon && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.ImageComponent, {
        width: "24px",
        height: "24px",
        src: btnLeftIcon,
        "data-test-id": "LandingButton-ImageComponent"
      }), customTitle && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.SpanTag, {
        color: _tm_utility_global__WEBPACK_IMPORTED_MODULE_2__/* .theme.blueText */ .rS.blueText,
        fontSize: "md",
        fontWeight: "black",
        "data-test-id": "LandingButton-SpanTag",
        children: customTitle
      }), shimmerBtn && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_LandingButton_style__WEBPACK_IMPORTED_MODULE_4__/* .ShimmerWrap */ .vj, {
        "data-test-id": "LandingButton-ShimmerWrap",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("img", {
          src: "../../../images/shimmerBtn.svg"
        })
      }), btnRightIcon && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.ImageComponent, {
        width: "16px",
        height: "16px",
        margin: "0 0 0 auto",
        src: btnRightIcon,
        "data-test-id": "LandingButton-ImageComponent"
      })]
    })
  });
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (LandingButton);

/***/ }),

/***/ 60707:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _tm_static__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48359);
/* harmony import */ var _tm_utility_global__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42874);
/* harmony import */ var _LandingButton_style__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45590);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52322);







const LandingButtonTertiary = ({
  title,
  disableState,
  onClick,
  btnLeftIcon,
  btnRightIcon
}) => {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(_LandingButton_style__WEBPACK_IMPORTED_MODULE_3__/* .LandingButtonTertiaryStyle */ .mS, {
    onClick: onClick,
    disableState: disableState,
    "data-test-id": "LandingButtonTertiary-LandingButtonTertiaryStyle",
    children: [btnLeftIcon && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.ImageComponent, {
      width: "24px",
      height: "24px",
      src: btnLeftIcon,
      "data-test-id": "LandingButtonTertiary-ImageComponent"
    }), title && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.SpanTag, {
      color: _tm_utility_global__WEBPACK_IMPORTED_MODULE_2__/* .theme.blueText */ .rS.blueText,
      fontSize: "xs",
      fontWeight: "bold",
      "data-test-id": "LandingButtonTertiary-SpanTag",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.FormattedText, {
        value: title,
        "data-test-id": "LandingButtonTertiary-FormattedText"
      })
    }), btnRightIcon && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.ImageComponent, {
      width: "16px",
      height: "16px",
      margin: "0 0 0 auto",
      src: btnRightIcon,
      "data-test-id": "LandingButtonTertiary-ImageComponent"
    })]
  });
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (LandingButtonTertiary);

/***/ }),

/***/ 95329:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _tm_static__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48359);
/* harmony import */ var _tm_utility_global__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42874);
/* harmony import */ var _LandingButton_style__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45590);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52322);







const LandingButtonWhite = ({
  customTitle,
  margin,
  customWidth,
  customHeight,
  disableState,
  onClick,
  flexShrink,
  flex,
  btnLeftIcon,
  btnRightIcon
}) => {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(_LandingButton_style__WEBPACK_IMPORTED_MODULE_3__/* .LandingButtonWhiteStyle */ .aA, {
    onClick: onClick,
    customWidth: customWidth,
    customHeight: customHeight,
    margin: margin,
    flexShrink: flexShrink,
    flex: flex,
    disableState: disableState,
    "data-test-id": "LandingButtonWhite-LandingButtonWhiteStyle",
    children: [btnLeftIcon && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.ImageComponent, {
      width: "24px",
      height: "24px",
      src: btnLeftIcon,
      "data-test-id": "LandingButtonWhite-ImageComponent"
    }), customTitle && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.SpanTag, {
      color: _tm_utility_global__WEBPACK_IMPORTED_MODULE_2__/* .theme.blueText */ .rS.blueText,
      fontSize: "md",
      fontWeight: "bold",
      "data-test-id": "LandingButtonWhite-SpanTag",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.FormattedText, {
        value: customTitle,
        "data-test-id": "LandingButtonWhite-FormattedText"
      })
    }), btnRightIcon && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.ImageComponent, {
      width: "16px",
      height: "16px",
      margin: "0 0 0 auto",
      src: btnRightIcon,
      "data-test-id": "LandingButtonWhite-ImageComponent"
    })]
  });
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (LandingButtonWhite);

/***/ }),

/***/ 51573:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ LandingButtonComp_LandingButtonComp)
});

// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/OmnitureAnalytics/insurance/index.ts + 5 modules
var insurance = __webpack_require__(83636);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/FormattedText/FormattedText.tsx
var FormattedText = __webpack_require__(17871);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/LandingButtonComp/LandingButtonComp.styles.ts

 // export const LandingButtonStyle = styled.button<ButtonInterface>`
//   ${(props) =>
//     props.disableState &&
//     `
//   background: ${theme.greyText2};
//   color: rgba(0, 0, 0, 0.3);
//   pointer-events:none;
//   `}
//   span {
//     font-size: ${(p) => (p.fontSize ? p.fontSize : "16px")};
//     font-weight: 900;
//     flex-shrink: 0;
//     color: #fff;
//     overflow: hidden;
//     text-overflow: ellipsis;
//     white-space: nowrap;
//     max-width: 100%;
//   }
// `;

const ButtonContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingButtonCompstyles__ButtonContainer",
  componentId: "sc-788uyy-0"
})(["background-image:", ";border-radius:8px;box-shadow:0px 1px 7px rgba(0,0,0,0.21);color:#fff;width:\"fit-content\";height:\"fit-content\";border:none;outline:none;cursor:pointer;position:relative;padding:12px 20px;text-transform:uppercase;flex-shrink:0;display:flex;align-items:center;justify-content:center;gap:8px;"], Global/* theme.blueGradient */.rS.blueGradient);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/LandingButtonComp/LandingButtonComp.tsx






const LandingButtonComp = ({
  buyButton,
  onPayment,
  isLoading
}) => {
  const analytics = (0,insurance/* getAnalytics */.I)();
  const {
    prefix,
    suffix
  } = buyButton;

  const handleBuyClick = () => {
    analytics?.trackTravDetailsEvents({
      actionType: "buy_clicked"
    });

    if (isLoading) {
      return;
    }

    if (onPayment) {
      onPayment();
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ButtonContainer, {
    onClick: handleBuyClick,
    "data-test-id": "LandingButtonComp-ButtonContainer",
    style: {
      cursor: isLoading ? "not-allowed" : "pointer",
      opacity: isLoading ? 0.6 : 1
    },
    "data-test-id": "LandingButtonComp-ButtonContainer",
    children: [prefix && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
      value: prefix,
      "data-test-id": "LandingButtonComp-FormattedText"
    }), suffix && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
      value: suffix,
      "data-test-id": "LandingButtonComp-FormattedText"
    })]
  });
};

/* harmony default export */ const LandingButtonComp_LandingButtonComp = (LandingButtonComp);

/***/ }),

/***/ 73517:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ LandingFaq_LandingFaq)
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/OmnitureAnalytics/insurance/index.ts + 5 modules
var insurance = __webpack_require__(83636);
// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/XDMAnalytics/index.ts
var XDMAnalytics = __webpack_require__(50354);
// EXTERNAL MODULE: ../../libs/ui/src/index.ts
var src = __webpack_require__(76609);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/index.ts + 2 modules
var ui_widgets_src = __webpack_require__(87109);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/CommonStyle/CommonStyles.style.ts
var CommonStyles_style = __webpack_require__(20984);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/FormattedText/FormattedText.tsx
var FormattedText = __webpack_require__(17871);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/RichText/RichText.tsx
var RichText = __webpack_require__(61643);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/utils/index.tsx
var utils = __webpack_require__(84576);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/LandingFaq/LandingFaq.style.ts



const LandingFaqStyle = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "LandingFaqstyle__LandingFaqStyle",
  componentId: "sc-1k4u026-0"
})(["", " display:flex;background:#fff;flex-direction:column;width:100%;", " ", ""], props => props.margin && `margin: ${props.margin};`, props => props.isCommonLanding && `
    width: 1200px;
    margin: 0 auto;
    padding: 24px;
    border-radius: 16px;
    background: #FFFFFF;
  `, props => props.customFaq && ``);
const LandingFaqTitle = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
  displayName: "LandingFaqstyle__LandingFaqTitle",
  componentId: "sc-1k4u026-1"
})(["font-family:\"Lato\";font-weight:400;font-size:48px;line-height:56px;margin-left:", ";margin-bottom:", ";color:", ";@media screen and ", "{font-weight:500;font-size:24px;line-height:32px;margin-bottom:8px;margin-left:", ";}"], props => props.marginLeft ? props.marginLeft : "0px", props => props.marginBottom ? props.marginBottom : "56px", Global/* theme.blackText */.rS.blackText, utils/* deviceType.mobile */.vO.mobile, props => props.marginLeft ? props.marginLeft : "0px");
const LandingFaqList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "LandingFaqstyle__LandingFaqList",
  componentId: "sc-1k4u026-2"
})(["width:", ";gap:16px;li{margin-bottom:16px;position:relative;cursor:pointer;}li h5{padding:24px;@media screen and ", "{padding:16px 35px 16px 16px;}}li p{padding:0 24px 24px;}li:after{content:\"\";position:absolute;border:solid black;border-width:0 3px 3px 0;display:inline-block;padding:3px;right:24px;top:33px;transition:0.3s ease-in;@media screen and ", "{top:16px;}}li.close:after{transform:rotate(45deg);-webkit-transform:rotate(45deg);}li.open:after{transform:rotate(-135deg);-webkit-transform:rotate(-135deg);}li:hover{background:#ffffff;box-shadow:0px 4px 16px rgba(0,0,0,0.16);border-radius:6px;}li:last-child{margin-bottom:unset;}", " @media screen and ", "{width:100%;}"], props => props.isCommonLanding ? `1150px` : `1000px`, utils/* deviceType.mobile */.vO.mobile, utils/* deviceType.mobile */.vO.mobile, props => props.customFaq && `
            width:100%;
            gap:8px;
            margin-bottom: 24px;
            li {
                padding: 12px 16px;
                background: #FFFFFF;
                box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.16);
                border-radius: 6px;
            }
            li h5 {
                padding: unset;
            }
            li p {
                padding:unset;
                font-size: 12px;
                line-height: 16px;
                color: #000000;
            }
            li:after {
                border: solid #008CFF;
                border-width: 0 2px 2px 0;
                padding: 4px;
                right: 24px;
                top: 13px;
            }
    `, utils/* deviceType.mobile */.vO.mobile);
const LandingFaqQues = styled_components_browser_esm/* default.h5.withConfig */.ZP.h5.withConfig({
  displayName: "LandingFaqstyle__LandingFaqQues",
  componentId: "sc-1k4u026-3"
})(["font-weight:700;font-size:22px;line-height:30px;color:#000;", " @media screen and ", "{font-weight:700;font-size:16px;line-height:20px;}"], props => props.customFaq && `
        font-size: 12px;
        line-height: 16px;
        color: #000000;`, utils/* deviceType.mobile */.vO.mobile);
const LandingFaqInfo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingFaqstyle__LandingFaqInfo",
  componentId: "sc-1k4u026-4"
})(["display:flex;padding:0px 24px 5px 0px;margin-bottom:16px;align-items:center;img{height:32px;width:32px;margin-right:10px;@media screen and ", "{height:24px;width:24px;margin-right:8px;}}@media screen and ", "{margin-left:16px;}font-family:lato,sans-serif;font-size:12px;line-height:14px;color:#757575;"], utils/* deviceType.mobile */.vO.mobile, utils/* deviceType.mobile */.vO.mobile);
const LandingFaqAns = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "LandingFaqstyle__LandingFaqAns",
  componentId: "sc-1k4u026-5"
})(["cursor:default;padding:0px !important;a{color:#008cff;}li:after{border:0px;border-width:0px;}"]);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/LandingFaq/LandingFaq.tsx











const analytics = (0,insurance/* getAnalytics */.I)();

const LandingFaq = ({
  customTitle,
  customFaq,
  faq,
  margin,
  customInfo,
  icon,
  isCommonLanding
}) => {
  const {
    0: exp,
    1: setExp
  } = (0,react.useState)(-1);
  const device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  const {
    type
  } = (0,src/* usePlanType */.U)();

  const handleClick = index => {
    analytics?.trackLandingEvents({
      actionType: `faq_section${index + 1}_clicked`
    }, "pageView", type);
    (0,XDMAnalytics.trackEvent)({
      event_detail: {
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: `faq_section${index + 1}_clicked`
      }
    });
    exp != index ? setExp(index) : setExp(-1);
  };

  (0,react.useEffect)(() => {
    faq?.map((item, index) => {
      const element = document.getElementById(`faq${index + 1}`);
      const observer = new IntersectionObserver(obCallback, {
        threshold: 1
      });
      element && observer.observe(element);

      function obCallback(entries) {
        if (entries[0].isIntersecting) {
          analytics?.trackLandingEvents({
            actionType: `faq_section${index + 1}_seen`
          }, "pageView", type);
          (0,XDMAnalytics.trackComponentView)({
            name: `faq_section${index + 1}_seen`,
            type: "faq"
          });
          observer.disconnect();
        }
      }
    });
  }, [faq]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(LandingFaqStyle, {
    margin: margin,
    customFaq: customFaq,
    isCommonLanding: isCommonLanding,
    "data-test-id": "LandingFaq-LandingFaqStyle",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(CommonStyles_style/* InnerContentWrap */.I, {
      "data-test-id": "LandingFaq-InnerContentWrap",
      children: [customTitle && /*#__PURE__*/(0,jsx_runtime.jsx)(LandingFaqTitle, {
        marginLeft: device === "sm" ? "16px" : "",
        marginBottom: "16px",
        "data-test-id": "LandingFaq-LandingFaqTitle",
        children: customTitle && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
          value: customTitle,
          "data-test-id": "LandingFaq-FormattedText"
        })
      }), customInfo && /*#__PURE__*/(0,jsx_runtime.jsxs)(LandingFaqInfo, {
        "data-test-id": "LandingFaq-LandingFaqInfo",
        children: [icon && /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          src: icon,
          alt: "Bot Icon"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
          value: customInfo,
          "data-test-id": "LandingFaq-FormattedText"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(LandingFaqList, {
        customFaq: customFaq,
        isCommonLanding: isCommonLanding,
        "data-test-id": "LandingFaq-LandingFaqList",
        children: faq.map((item, index) => {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
            className: `${exp == index ? "open" : "close"}`,
            id: `faq${index + 1}`,
            "data-test-id": `LandingFaq-${index}`,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LandingFaqQues, {
              customFaq: customFaq,
              onClick: () => handleClick(index),
              "data-test-id": "LandingFaq-LandingFaqQues",
              children: item.ques && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
                value: item.ques,
                "data-test-id": "LandingFaq-FormattedText"
              })
            }), exp == index && /*#__PURE__*/(0,jsx_runtime.jsx)(LandingFaqAns, {
              "data-test-id": "LandingFaq-LandingFaqAns",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                children: item.info && /*#__PURE__*/(0,jsx_runtime.jsx)(RichText/* default */.Z, {
                  value: item.info,
                  "data-test-id": "LandingFaq-RichText"
                })
              })
            })]
          }, index);
        })
      })]
    })
  });
};

/* harmony default export */ const LandingFaq_LandingFaq = (LandingFaq);

/***/ }),

/***/ 71791:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ LandingFooter_LandingFooter)
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/utils/index.tsx
var utils = __webpack_require__(84576);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/LandingFooter/LandingFooter.style.ts



const LandingFooterStyle = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "LandingFooterstyle__LandingFooterStyle",
  componentId: "d0b0t6-0"
})(["background:", ";color:", ";padding:", ";width:100%;@media screen and ", "{padding-bottom:22px;}"], ({
  footerTheme,
  isCommonLandingRevamp
}) => footerTheme === "light" ? isCommonLandingRevamp ? Global/* theme.lightGreyBG */.rS.lightGreyBG : Global/* theme.whiteText */.rS.whiteText : Global/* theme.blackText */.rS.blackText, ({
  footerTheme
}) => footerTheme === "light" ? Global/* theme.blackText */.rS.blackText : Global/* theme.whiteText */.rS.whiteText, ({
  footerTheme
}) => footerTheme === "light" ? "0" : "32px 0 64px", utils/* deviceType.mobile */.vO.mobile);
const ChevronContainerIcon = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "LandingFooterstyle__ChevronContainerIcon",
  componentId: "d0b0t6-1"
})(["transform:", ";"], props => props.isInvert ? "rotate(180deg)" : "rotate(0deg)");
const LinksContainer = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "LandingFooterstyle__LinksContainer",
  componentId: "d0b0t6-2"
})(["margin-bottom:", ";& > li:not(:last-child){margin-bottom:20px;}& > li:hover{text:", ";}@media screen and ", "{margin-bottom:40px;& > li{padding:16px;border-bottom:1px ", " solid;}& > li:not(:last-child){margin-bottom:unset;}}"], p => p.isCopyrightText ? "100px" : "0", Global/* theme.blueText */.rS.blueText, utils/* deviceType.mobile */.vO.mobile, Global/* theme.greyText */.rS.greyText);
const FooterSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingFooterstyle__FooterSection",
  componentId: "d0b0t6-3"
})(["@media screen and ", "{width:100%;}"], utils/* deviceType.mobile */.vO.mobile);
const InnerLinksContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingFooterstyle__InnerLinksContainer",
  componentId: "d0b0t6-4"
})(["display:flex;margin-top:10px;flex-wrap:wrap;width:100%;color:", ";font-size:12px;line-height:16px;"], ({
  footerTheme
}) => footerTheme === "light" ? Global/* theme.greyText */.rS.greyText : Global/* theme.whiteText */.rS.whiteText);
const LandingFooterWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingFooterstyle__LandingFooterWrap",
  componentId: "d0b0t6-5"
})(["margin:0 auto;width:1200px;@media screen and ", "{width:100%;}"], utils/* deviceType.mobile */.vO.mobile);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/icons/index.ts + 7 modules
var icons = __webpack_require__(64204);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/index.tsx + 12 modules
var components = __webpack_require__(48359);
// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/OmnitureAnalytics/insurance/index.ts + 5 modules
var insurance = __webpack_require__(83636);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/index.ts + 2 modules
var src = __webpack_require__(87109);
// EXTERNAL MODULE: ../../libs/ui/src/lib/hooks/index.ts + 1 modules
var hooks = __webpack_require__(89565);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/LandingFooter/LandingFooter.tsx












const LandingFooter = ({
  footerData,
  footerHeading,
  downIcon,
  footerCopyrightData,
  footerTheme = "dark",
  isCommonLandingRevamp = false
}) => {
  const analytics = (0,insurance/* getAnalytics */.I)();
  const hasTracked = (0,react.useRef)(false); // Track component view when it comes into viewport

  const handleIntersection = (0,react.useCallback)(data => {
    if (!hasTracked.current) {
      analytics?.trackLandingEvents({
        actionType: "footer_seen"
      });
    }

    hasTracked.current = true;
  }, []);
  const {
    ref: footerRef
  } = (0,hooks/* useIntersectionObserver */.S)(handleIntersection, {
    threshold: 0.5,
    // Trigger when 50% of component is visible
    triggerOnLeaveViewport: true
  });

  if (footerData.length === 0 && !footerHeading && !footerCopyrightData) {
    return null;
  }

  const device = (0,src/* useBreakpointV2 */.bU)();
  const {
    0: activeIdx,
    1: setActiveIdx
  } = (0,react.useState)(-1);
  let footerTextOne = "";
  let headerAlt = "";
  let headerImg = "";
  let footerTextTwo = "";
  const regex = /^(.*?)!\[(.*?)\]\((.*?)\)(.*?)$/;
  const match = footerHeading?.value?.match(regex);

  if (match) {
    footerTextOne = match[1].trim();
    headerAlt = match[2].trim();
    headerImg = match[3].trim();
    footerTextTwo = match[4].trim();
  }

  const copyrightText = footerCopyrightData?.items?.find(item => item.type === "copyright")?.value;

  const optionsHandler = index => {
    if (activeIdx === index) {
      setActiveIdx(-1);
      return;
    }

    setActiveIdx(index);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(LandingFooterStyle, {
    ref: footerRef,
    footerTheme: footerTheme,
    isCommonLandingRevamp: isCommonLandingRevamp,
    "data-test-id": "LandingFooter-LandingFooterStyle",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(LandingFooterWrap, {
      "data-test-id": "LandingFooter-LandingFooterWrap",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(FooterSection, {
        "data-test-id": "LandingFooter-FooterSection",
        children: [footerHeading && /*#__PURE__*/(0,jsx_runtime.jsxs)(components.FlexComp, {
          alignItems: "center",
          justifyContent: device === "sm" ? "center" : undefined,
          margin: "0px 0px 50px 0px",
          "data-test-id": "LandingFooter-FlexComp",
          children: [footerTextOne && /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
            fontSize: device == "lg" ? "sm" : "xxs",
            margin: "0px 8px 4px 0px",
            color: footerTheme === "light" ? Global/* theme.blackText */.rS.blackText : "white",
            "data-test-id": "LandingFooter-SpanTag",
            children: footerTextOne
          }), headerImg ? /*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
            width: "85px",
            height: "27px",
            src: headerImg,
            alt: headerAlt,
            "data-test-id": "LandingFooter-ImageComponent"
          }) : null, footerTextTwo && /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
            fontSize: device == "lg" ? "sm" : "xxs",
            margin: "0px 0px 4px 8px",
            color: footerTheme === "light" ? Global/* theme.blackText */.rS.blackText : "white",
            "data-test-id": "LandingFooter-SpanTag",
            children: footerTextTwo
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(LinksContainer, {
          isCopyrightText: !!copyrightText,
          "data-test-id": "LandingFooter-LinksContainer",
          children: footerData?.map((item, idx) => {
            return item?.label && /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
              onClick: device === "sm" ? () => optionsHandler(idx) : undefined,
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components.FlexComp, {
                justifyContent: device === "sm" ? "space-between" : undefined,
                gap: "8px",
                alignItems: "center",
                "data-test-id": "LandingFooter-FlexComp",
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components.FlexComp, {
                  gap: "10px",
                  "data-test-id": "LandingFooter-FlexComp",
                  children: [item?.icon && /*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
                    width: "18px",
                    height: "18px",
                    src: item.icon,
                    "data-test-id": "LandingFooter-ImageComponent"
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.ParaTag, {
                    color: footerTheme === "light" ? Global/* theme.blackText */.rS.blackText : "white",
                    fontWeight: "black",
                    fontSize: "xxs",
                    lineHeight: "10px",
                    textTransform: "uppercase",
                    "data-test-id": "LandingFooter-ParaTag",
                    children: item.label
                  })]
                }), device === "sm" && /*#__PURE__*/(0,jsx_runtime.jsx)(ChevronContainerIcon, {
                  isInvert: activeIdx !== idx,
                  "data-test-id": "LandingFooter-ChevronContainerIcon",
                  children: downIcon ? /*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageTag, {
                    src: downIcon,
                    "data-test-id": "LandingFooter-ImageTag"
                  }) : /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* ChevronUpIcon */.g8, {
                    "data-test-id": "LandingFooter-ChevronUpIcon"
                  })
                })]
              }), device === "lg" ? /*#__PURE__*/(0,jsx_runtime.jsx)(InnerLinksContainer, {
                footerTheme: footerTheme,
                "data-test-id": "LandingFooter-InnerLinksContainer",
                children: item?.listPoints?.map((point, index) => /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(components.AnchorTag, {
                    color: footerTheme === "light" ? Global/* theme.greyText */.rS.greyText : "white",
                    fontSize: "xs",
                    lineHeight: "14px",
                    hrefProp: point.link || "#",
                    "data-test-id": "LandingFooter-AnchorTag",
                    children: [point.label, index < item.listPoints.length - 1 && /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
                      color: footerTheme === "light" ? Global/* theme.greyText */.rS.greyText : "white",
                      fontSize: "xs",
                      "data-test-id": "LandingFooter-SpanTag",
                      children: ",\xA0"
                    })]
                  }, point.id)
                }))
              }) : activeIdx === idx && /*#__PURE__*/(0,jsx_runtime.jsx)(InnerLinksContainer, {
                "data-test-id": "LandingFooter-InnerLinksContainer",
                children: item.listPoints.map((point, index) => /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.AnchorTag, {
                    color: "#fff",
                    fontSize: "xs",
                    lineHeight: "14px",
                    hrefProp: point.link || "#",
                    "data-test-id": "LandingFooter-AnchorTag",
                    children: point.label
                  }, point.id), index < item.listPoints.length - 1 && /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
                    color: "#fff",
                    fontSize: "xs",
                    "data-test-id": "LandingFooter-SpanTag",
                    children: ",\xA0"
                  })]
                }))
              })]
            }, item.id);
          })
        })]
      })
    })
  });
};

/* harmony default export */ const LandingFooter_LandingFooter = (LandingFooter);

/***/ }),

/***/ 19394:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ LandingFooterInsurance)
});

// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/index.tsx + 12 modules
var components = __webpack_require__(48359);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/CommonStyle/CommonStyles.style.ts
var CommonStyles_style = __webpack_require__(20984);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/icons/BlogIcon.svg
var BlogIcon = __webpack_require__(45763);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/icons/CitiesIcon.svg
var CitiesIcon = __webpack_require__(67167);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/icons/FollowIcon.svg
var FollowIcon = __webpack_require__(2703);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/icons/MmtInitiative.png
var MmtInitiative = __webpack_require__(32770);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/icons/QuickLinks.svg
var QuickLinks = __webpack_require__(60582);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/icons/twitterIcon.png
var twitterIcon = __webpack_require__(17766);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/LandingFooter/LandingFooter2.style.ts

const LandingFooterStyle = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "LandingFooter2style__LandingFooterStyle",
  componentId: "sc-1fi2m66-0"
})(["background:#000;padding-top:32px;padding-bottom:64px;width:100%;"]);
const LandingFooterSub = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingFooter2style__LandingFooterSub",
  componentId: "sc-1fi2m66-1"
})(["display:flex;align-items:center;gap:10px;margin-bottom:14px;", ""], p => p.openedLink && ``);
const LandingFooterWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingFooter2style__LandingFooterWrap",
  componentId: "sc-1fi2m66-2"
})(["margin:0 auto;width:1200px;"]);
const LandingFooterImg = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingFooter2style__LandingFooterImg",
  componentId: "sc-1fi2m66-3"
})(["width:325px;height:27px;margin-bottom:50px;"]);
const LandingFooterList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "LandingFooter2style__LandingFooterList",
  componentId: "sc-1fi2m66-4"
})(["display:flex;gap:10px;margin-bottom:26px;width:964px;flex-wrap:wrap;margin:", ";li{position:relative;}li:last-child{position:static;}li:after{content:\"\";position:absolute;width:4px;height:4px;border-radius:100%;background:#fff;top:12px;right:-7px;}li:last-child:after{width:0;height:0;}li a{font-weight:400;font-size:12px;line-height:16px;color:#ffffff;}&:last-child{margin-bottom:100px;}", ""], props => props.margin ? props.margin : "", props => props.flexWrap && `
      height:198px;
      flex-wrap:wrap;
  `);
const LandingFooterFlex = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingFooter2style__LandingFooterFlex",
  componentId: "sc-1fi2m66-5"
})(["display:flex;gap:95px;margin-top:100px;"]);
const LandingFooterCopyRight = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingFooter2style__LandingFooterCopyRight",
  componentId: "sc-1fi2m66-6"
})(["display:flex;flex-direction:column;align-items:flex-end;margin-left:auto;align-self:center;span:nth-child(2){font-weight:600;margin-top:3px;}"]);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/LandingFooter/LandingFooterInsurance.tsx













const footerLinks = {
  cities: ["Mumbai", "Bengaluru", "Chennai", "Pune", "Hyderabad", "Kolkata", "Lucknow", "Jaipur", "Surat", "Bhopal", "Goa", "Noida", "Thane", "Varanasi"],
  blog: ["Mumbai", "Bengaluru", "Chennai", "Pune", "Hyderabad", "Kolkata", "Lucknow", "Jaipur", "Surat", "Bhopal", "Goa", "Noida", "Thane", "Varanasi", "Mumbai", "Bengaluru", "Chennai", "Pune", "Hyderabad", "Kolkata", "Lucknow", "Jaipur", "Surat", "Bhopal", "Goa", "Noida", "Thane", "Varanasi", "Mumbai", "Bengaluru", "Chennai", "Pune", "Hyderabad", "Kolkata", "Lucknow", "Jaipur", "Surat", "Bhopal", "Goa", "Noida", "Thane", "Varanasi"],
  quickLinks: ["Mumbai", "Bengaluru", "Chennai", "Pune", "Hyderabad", "Kolkata", "Lucknow", "Jaipur", "Surat", "Bhopal", "Goa", "Noida", "Thane", "Varanasi"],
  others: ["About us", "Privacy Policy", "User Agreement", " Terms of Services", " Mail us"]
};

const LandingFooter = ({}) => {
  const {
    0: link,
    1: setLink
  } = (0,react.useState)(-1);

  const handleClick = index => {
    index != index ? setLink(index) : setLink(-1);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(LandingFooterStyle, {
    "data-test-id": "LandingFooter-LandingFooterStyle",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(CommonStyles_style/* InnerContentWrap */.I, {
      "data-test-id": "LandingFooter-InnerContentWrap",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(LandingFooterWrap, {
        "data-test-id": "LandingFooter-LandingFooterWrap",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LandingFooterImg, {
          "data-test-id": "LandingFooter-LandingFooterImg",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
            width: "325px",
            height: "27px",
            src: MmtInitiative/* default.src */.Z.src,
            "data-test-id": "LandingFooter-ImageComponent"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(LandingFooterSub, {
          "data-test-id": "LandingFooter-LandingFooterSub",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
            width: "20px",
            height: "20px",
            src: CitiesIcon/* default.src */.Z.src,
            "data-test-id": "LandingFooter-ImageComponent"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
            fontSize: "sm",
            fontWeight: "bold",
            color: Global/* theme.whiteText */.rS.whiteText,
            "data-test-id": "LandingFooter-SpanTag",
            children: "BUSINESS CITIES"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(LandingFooterList, {
          "data-test-id": "LandingFooter-LandingFooterList",
          children: footerLinks.cities && footerLinks.cities.map((item, index) => {
            return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              "data-test-id": `LandingFooter-${index}`,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.AnchorTag, {
                color: Global/* theme.whiteText */.rS.whiteText,
                "aria-label": "cities",
                hrefProp: "#",
                "data-test-id": "LandingFooter-AnchorTag",
                children: item
              })
            }, index);
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(LandingFooterSub, {
          "data-test-id": "LandingFooter-LandingFooterSub",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
            width: "20px",
            height: "20px",
            src: BlogIcon/* default.src */.Z.src,
            "data-test-id": "LandingFooter-ImageComponent"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components.SpanTag, {
            fontSize: "sm",
            fontWeight: "bold",
            color: Global/* theme.whiteText */.rS.whiteText,
            "data-test-id": "LandingFooter-SpanTag",
            children: [" ", "BLOG"]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(LandingFooterList, {
          "data-test-id": "LandingFooter-LandingFooterList",
          children: footerLinks.blog && footerLinks.blog.map((item, index) => {
            return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              "data-test-id": `LandingFooter-${index}`,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.AnchorTag, {
                color: Global/* theme.whiteText */.rS.whiteText,
                "aria-label": "blog",
                hrefProp: "#",
                "data-test-id": "LandingFooter-AnchorTag",
                children: item
              })
            }, index);
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(LandingFooterSub, {
          "data-test-id": "LandingFooter-LandingFooterSub",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
            width: "20px",
            height: "20px",
            src: QuickLinks/* default.src */.Z.src,
            "data-test-id": "LandingFooter-ImageComponent"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components.SpanTag, {
            fontSize: "sm",
            fontWeight: "bold",
            color: Global/* theme.whiteText */.rS.whiteText,
            "data-test-id": "LandingFooter-SpanTag",
            children: [" ", "QUICK LINKS"]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(LandingFooterList, {
          "data-test-id": "LandingFooter-LandingFooterList",
          children: footerLinks.quickLinks && footerLinks.quickLinks.map((item, index) => {
            return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              "data-test-id": `LandingFooter-${index}`,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.AnchorTag, {
                color: Global/* theme.whiteText */.rS.whiteText,
                hrefProp: "#",
                "data-test-id": "LandingFooter-AnchorTag",
                children: item
              })
            }, index);
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(LandingFooterSub, {
          "data-test-id": "LandingFooter-LandingFooterSub",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
            width: "20px",
            height: "20px",
            src: "https://tripmoneycmsimgak.mmtcdn.com/img/other_Icon_5614215b70.png",
            "data-test-id": "LandingFooter-ImageComponent"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components.SpanTag, {
            fontSize: "sm",
            fontWeight: "bold",
            color: Global/* theme.whiteText */.rS.whiteText,
            "data-test-id": "LandingFooter-SpanTag",
            children: [" ", "OTHERS"]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(LandingFooterList, {
          "data-test-id": "LandingFooter-LandingFooterList",
          children: footerLinks.others && footerLinks.others.map((item, index) => {
            return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              "data-test-id": `LandingFooter-${index}`,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.AnchorTag, {
                color: Global/* theme.whiteText */.rS.whiteText,
                hrefProp: "#",
                "data-test-id": "LandingFooter-AnchorTag",
                children: item
              })
            }, index);
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(LandingFooterFlex, {
          "data-test-id": "LandingFooter-LandingFooterFlex",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(LandingFooterSub, {
              "data-test-id": "LandingFooter-LandingFooterSub",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
                width: "18px",
                height: "18px",
                src: FollowIcon/* default.src */.Z.src,
                "data-test-id": "LandingFooter-ImageComponent"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
                fontSize: "sm",
                fontWeight: "bold",
                color: Global/* theme.whiteText */.rS.whiteText,
                "data-test-id": "LandingFooter-SpanTag",
                children: "FOLLOW US"
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components.FlexComp, {
              gap: "16px",
              "data-test-id": "LandingFooter-FlexComp",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.AnchorTag, {
                hrefProp: "#",
                "data-test-id": "LandingFooter-AnchorTag",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
                  width: "27px",
                  height: "27px",
                  src: twitterIcon/* default.src */.Z.src,
                  "data-test-id": "LandingFooter-ImageComponent"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.AnchorTag, {
                hrefProp: "#",
                "data-test-id": "LandingFooter-AnchorTag",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
                  width: "27px",
                  height: "27px",
                  src: "https://tripmoneycmsimgak.mmtcdn.com/img/fb_Icon_8eab71f726.png",
                  "data-test-id": "LandingFooter-ImageComponent"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.AnchorTag, {
                "aria-label": "linkedin",
                hrefProp: "#",
                "data-test-id": "LandingFooter-AnchorTag",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
                  width: "27px",
                  height: "27px",
                  src: "https://tripmoneycmsimgak.mmtcdn.com/img/Linkedin_Icon_fec59ba5c7.png",
                  "data-test-id": "LandingFooter-ImageComponent"
                })
              })]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(LandingFooterSub, {
              "data-test-id": "LandingFooter-LandingFooterSub",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
                width: "18px",
                height: "18px",
                src: "https://tripmoneycmsimgak.mmtcdn.com/img/download_Icon_f3c8f1d5d2.png",
                "data-test-id": "LandingFooter-ImageComponent"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
                fontSize: "sm",
                fontWeight: "bold",
                color: Global/* theme.whiteText */.rS.whiteText,
                "data-test-id": "LandingFooter-SpanTag",
                children: "DOWNLOAD"
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components.FlexComp, {
              gap: "10px",
              "data-test-id": "LandingFooter-FlexComp",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.AnchorTag, {
                hrefProp: "#",
                "data-test-id": "LandingFooter-AnchorTag",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
                  width: "128px",
                  height: "36px",
                  src: "https://tripmoneycmsimgak.mmtcdn.com/img/play_Store_Icon_ddbbe2de64.png",
                  "data-test-id": "LandingFooter-ImageComponent"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.AnchorTag, {
                hrefProp: "#",
                "data-test-id": "LandingFooter-AnchorTag",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
                  width: "128px",
                  height: "36px",
                  src: "https://tripmoneycmsimgak.mmtcdn.com/img/app_Store_Icon_07d258a1b2.png",
                  "data-test-id": "LandingFooter-ImageComponent"
                })
              })]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(LandingFooterCopyRight, {
            "data-test-id": "LandingFooter-LandingFooterCopyRight",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components.SpanTag, {
              fontSize: "xs",
              color: Global/* theme.whiteText */.rS.whiteText,
              fontWeight: "bold",
              "data-test-id": "LandingFooter-SpanTag",
              children: [" ", "\xA9 2022 MAKEMYTRIP PVT.LTD"]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
              fontSize: "xs",
              color: Global/* theme.whiteText */.rS.whiteText,
              fontWeight: "bold",
              "data-test-id": "LandingFooter-SpanTag",
              children: "Country India"
            })]
          })]
        })]
      })
    })
  });
};

/* harmony default export */ const LandingFooterInsurance = (LandingFooter);

/***/ }),

/***/ 28254:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "At": () => (/* binding */ LandingHeaderStyle),
/* harmony export */   "CZ": () => (/* binding */ ProductLinks),
/* harmony export */   "GF": () => (/* binding */ LandingHeaderBtn),
/* harmony export */   "GY": () => (/* binding */ LandingHeaderMobBlack),
/* harmony export */   "I8": () => (/* binding */ LandingHeaderWrap),
/* harmony export */   "N2": () => (/* binding */ LandingHeaderList),
/* harmony export */   "Pr": () => (/* binding */ LandingHeaderItem),
/* harmony export */   "XB": () => (/* binding */ ImageIcon),
/* harmony export */   "gF": () => (/* binding */ LandingHeaderMob),
/* harmony export */   "kC": () => (/* binding */ Flex)
/* harmony export */ });
/* unused harmony export TmLogo */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82740);
/* harmony import */ var _TextStyles_TextStyles_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93139);


const LandingHeaderStyle = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].header.withConfig */ .ZP.header.withConfig({
  displayName: "LandingHeaderstyle__LandingHeaderStyle",
  componentId: "sc-2vdv0h-0"
})(["height:80px;width:100%;background:rgba(0,0,0);color:rgba(255,255,255,0.6);z-index:40;box-shadow:0px 1px 16px rgba(0,0,0,0.2);position:sticky;top:0;.displayNone{display:none;}"]);
const LandingHeaderWrap = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "LandingHeaderstyle__LandingHeaderWrap",
  componentId: "sc-2vdv0h-1"
})(["width:1200px;margin:0 auto;display:flex;align-items:center;justify-content:space-between;height:80px;position:relative;z-index:100;background:#000;z-index:40;"]);
const TmLogo = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].a.withConfig */ .ZP.a.withConfig({
  displayName: "LandingHeaderstyle__TmLogo",
  componentId: "sc-2vdv0h-2"
})(["width:140px;height:40px;flex-shrink:0;opacity:0;"]);
const LandingHeaderList = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ul.withConfig */ .ZP.ul.withConfig({
  displayName: "LandingHeaderstyle__LandingHeaderList",
  componentId: "sc-2vdv0h-3"
})(["margin-left:auto;display:flex;align-items:center;gap:32px;cursor:pointer;"]);
const LandingHeaderItem = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].li.withConfig */ .ZP.li.withConfig({
  displayName: "LandingHeaderstyle__LandingHeaderItem",
  componentId: "sc-2vdv0h-4"
})(["position:relative;& a{color:inherit;font-weight:400;font-size:16px;line-height:22px;}&:first-child{margin-right:16px;}&:first-child:after{content:\"\";position:absolute;border:solid #008cff;border-width:0 2px 2px 0;display:inline-block;padding:4px;top:3px;right:-22px;transition:ease-in 0.4s;", " ", "}"], p => p.opened && `
        transform: rotate(-135deg);
        -webkit-transform: rotate(-135deg);
        top: 9px;
        `, p => p.closed && `
        transform: rotate(45deg);
        -webkit-transform: rotate(45deg);
        `);
const LandingHeaderBtn = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].button.withConfig */ .ZP.button.withConfig({
  displayName: "LandingHeaderstyle__LandingHeaderBtn",
  componentId: "sc-2vdv0h-5"
})(["width:90px;height:44px;display:flex;align-items:center;justify-content:center;border:none;outline:none;font-weight:900;color:#008cff;font-size:16px;line-height:20px;margin-left:45px;border-radius:96px;background:linear-gradient(0deg,#ffffff,#ffffff),linear-gradient(93.66deg,#249083 0%,#249054 100%),#ffffff;box-shadow:0px 1px 7px rgba(0,0,0,0.2);-webkit-box-shadow:0px 1px 7px rgba(0,0,0,0.2);-webkit-appearance:none;cursor:pointer;"]);
const ProductLinks = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "LandingHeaderstyle__ProductLinks",
  componentId: "sc-2vdv0h-6"
})(["background:#ffffff;box-shadow:0px 2px 16px rgba(0,0,0,0.16);border-radius:6px;padding:24px 16px;position:absolute;top:35px;left:0;width:230px;display:flex;flex-direction:column;gap:24px;a{width:100%;font-style:normal;font-weight:400;font-size:14px;line-height:20px;color:#4a4a4a;}"]);
const Flex = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "LandingHeaderstyle__Flex",
  componentId: "sc-2vdv0h-7"
})(["display:flex;align-items:center;font-weight:700;font-size:10px;line-height:12px;color:#ffffff;cursor:pointer;svg{margin-left:8px;}"]);
const ImageIcon = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "LandingHeaderstyle__ImageIcon",
  componentId: "sc-2vdv0h-8"
})(["width:21px;height:21px;border-radius:100%;margin-right:10px;background:#000;color:#fff;font-weight:700;font-size:10px;line-height:12px;color:#ffffff;display:flex;align-items:center;justify-content:center;flex-shrink:0;"]);
const LandingHeaderMob = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "LandingHeaderstyle__LandingHeaderMob",
  componentId: "sc-2vdv0h-9"
})(["background:#fff;padding:16px;display:flex;flex-direction:column;gap:16px;box-shadow:0px 1px 16px rgba(0,0,0,0.2);position:sticky;top:0;z-index:4;", "{display:flex;}"], _TextStyles_TextStyles_style__WEBPACK_IMPORTED_MODULE_1__/* .AnchorTagStyle */ .C2);
const LandingHeaderMobBlack = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "LandingHeaderstyle__LandingHeaderMobBlack",
  componentId: "sc-2vdv0h-10"
})(["background:transparent;padding:16px;display:flex;flex-direction:column;gap:16px;position:sticky;top:0;z-index:4;", " ", "{display:flex;}picture{width:75px;height:24px;}", ""], p => p.displayWhiteHeader && `
    background:#fff;
    box-shadow: 0px 1px 16px rgba(0, 0, 0, 0.2);
    `, _TextStyles_TextStyles_style__WEBPACK_IMPORTED_MODULE_1__/* .AnchorTagStyle */ .C2, p => p.insuranceHeader && `
    position:fixed;
    top:0;
    width:100%;
    left:0;
    right:0;
    `);

/***/ }),

/***/ 18835:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _tm_static__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48359);
/* harmony import */ var _tm_static_icons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64204);
/* harmony import */ var _tm_utility_global__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42874);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2784);
/* harmony import */ var _LandingHeader_style__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28254);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52322);







const productLinks = ["Foreign Currency", "Forex Cards", "Travel Insurance", "Travel Loan", "Foreign Money Trasfer"];

const LandingHeader = ({
  loginState,
  logoUrl
}) => {
  const {
    0: show,
    1: setShow
  } = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false);

  const handleClick = () => {
    setShow(!show);
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_LandingHeader_style__WEBPACK_IMPORTED_MODULE_4__/* .LandingHeaderStyle */ .At, {
    id: "header-id",
    "data-test-id": "LandingHeader-LandingHeaderStyle",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_LandingHeader_style__WEBPACK_IMPORTED_MODULE_4__/* .LandingHeaderWrap */ .I8, {
      id: "headerWrap-id",
      "data-test-id": "LandingHeader-LandingHeaderWrap",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.AnchorTag, {
        "data-test-id": "LandingHeader-AnchorTag",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_tm_static_icons__WEBPACK_IMPORTED_MODULE_1__/* .TripMoneyLogo */ .im, {
          "data-test-id": "LandingHeader-TripMoneyLogo"
        })
      }), !loginState && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(react__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_LandingHeader_style__WEBPACK_IMPORTED_MODULE_4__/* .LandingHeaderList */ .N2, {
          "data-test-id": "LandingHeader-LandingHeaderList",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_LandingHeader_style__WEBPACK_IMPORTED_MODULE_4__/* .LandingHeaderItem */ .Pr, {
            opened: show,
            closed: !show,
            onClick: handleClick,
            "data-test-id": "LandingHeader-LandingHeaderItem",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.AnchorTag, {
              hrefProp: "#",
              "aria-label": "products",
              "data-test-id": "LandingHeader-AnchorTag",
              children: "Products"
            }), show && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_LandingHeader_style__WEBPACK_IMPORTED_MODULE_4__/* .ProductLinks */ .CZ, {
              "data-test-id": "LandingHeader-ProductLinks",
              children: productLinks && productLinks.map((item, index) => {
                return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.AnchorTag, {
                  hrefProp: "#",
                  "data-test-id": `LandingHeader-AnchorTag-${index}`,
                  children: item
                }, index);
              })
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_LandingHeader_style__WEBPACK_IMPORTED_MODULE_4__/* .LandingHeaderItem */ .Pr, {
            "data-test-id": "LandingHeader-LandingHeaderItem",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.AnchorTag, {
              hrefProp: "#",
              "data-test-id": "LandingHeader-AnchorTag",
              children: "Blogs"
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_LandingHeader_style__WEBPACK_IMPORTED_MODULE_4__/* .LandingHeaderItem */ .Pr, {
            "data-test-id": "LandingHeader-LandingHeaderItem",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.AnchorTag, {
              hrefProp: "#",
              "data-test-id": "LandingHeader-AnchorTag",
              children: "FAQ\u2019s"
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_LandingHeader_style__WEBPACK_IMPORTED_MODULE_4__/* .LandingHeaderItem */ .Pr, {
            "data-test-id": "LandingHeader-LandingHeaderItem",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.AnchorTag, {
              hrefProp: "#",
              "data-test-id": "LandingHeader-AnchorTag",
              children: "About Us"
            })
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_LandingHeader_style__WEBPACK_IMPORTED_MODULE_4__/* .LandingHeaderBtn */ .GF, {
          "data-test-id": "LandingHeader-LandingHeaderBtn",
          children: "LOGIN"
        })]
      }), loginState && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_LandingHeader_style__WEBPACK_IMPORTED_MODULE_4__/* .Flex */ .kC, {
        "data-test-id": "LandingHeader-Flex",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_LandingHeader_style__WEBPACK_IMPORTED_MODULE_4__/* .ImageIcon */ .XB, {
          "data-test-id": "LandingHeader-ImageIcon",
          children: "T"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.SpanTag, {
          fontSize: "xxs",
          color: _tm_utility_global__WEBPACK_IMPORTED_MODULE_2__/* .theme.whiteText */ .rS.whiteText,
          fontWeight: "bold",
          "data-test-id": "LandingHeader-SpanTag",
          children: "Hey Traveller"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.ImageComponent, {
          width: "14px",
          height: "14px",
          src: "https://tripmoneycmsimgak.mmtcdn.com/img/white_Chev_8257cb46d7.svg",
          "data-test-id": "LandingHeader-ImageComponent"
        })]
      })]
    })
  });
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (LandingHeader);

/***/ }),

/***/ 63590:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ LandingHeader_LandingHeaderMobile)
});

// EXTERNAL MODULE: ../../libs/utility/src/lib/insurance/utils/index.ts + 5 modules
var utils = __webpack_require__(62663);
// EXTERNAL MODULE: ../../libs/isomorphic-utils/src/index.ts + 7 modules
var src = __webpack_require__(44928);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/index.tsx + 12 modules
var components = __webpack_require__(48359);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/index.ts + 2 modules
var ui_widgets_src = __webpack_require__(87109);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/FormattedText/FormattedText.tsx
var FormattedText = __webpack_require__(17871);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/LandingHeader/LandingHeader.style.ts
var LandingHeader_style = __webpack_require__(28254);
// EXTERNAL MODULE: ../../libs/utility/src/lib/insurance/navigation/index.ts + 5 modules
var navigation = __webpack_require__(576);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/hooks/index.ts + 2 modules
var hooks = __webpack_require__(48619);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/LandingHeader/LandingHeaderBackButton.tsx




const LandingHeaderBackButton = props => {
  const serverReferrer = (0,hooks/* useReferrerContext */.u)();

  const handleBackButton = () => {
    if (props.exitWebViewOnBack && window.mmt_android_bridge) {
      window.mmt_android_bridge.closeWebView();
    } else if (serverReferrer) {
      navigation/* navigationActions.goBack */.ej.goBack();
    } else {
      history.back();
    }
  };

  const {
    handleBackBtn = handleBackButton,
    displayWhiteHeader,
    showPwaHeaderBackButton = true
  } = props;
  return showPwaHeaderBackButton && handleBackBtn ? /*#__PURE__*/(0,jsx_runtime.jsx)(components.AnchorTag, {
    handleClick: handleBackBtn,
    "data-test-id": "LandingHeaderBackButton-AnchorTag",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M12 20L4 12L12 4L13.425 5.4L7.825 11H20V13H7.825L13.425 18.6L12 20Z",
        fill: "#4A4A4A"
      })
    })
  }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    style: {
      width: "24px",
      height: "24px"
    }
  });
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/LandingHeader/LandingHeaderMobile.tsx











const LandingHeaderMobile = ({
  handleBackBtn,
  headerTitle,
  children,
  myOrders,
  goToMyOrders,
  displayWhiteHeader,
  partnerType,
  insuranceHeader,
  exitWebViewOnBack,
  showPwaHeaderBackButton = true
}) => {
  const {
    0: isScrolledPast40,
    1: setIsScrolledPast40
  } = (0,react.useState)(false);
  const device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  const {
    0: isLoggedIn,
    1: setIsLoggedIn
  } = (0,react.useState)(false);
  (0,react.useEffect)(() => {
    const handleScroll = () => {
      const currentScrollPos = window.scrollY;
      const shouldShowWhiteHeader = currentScrollPos > 40; // Only update state if the threshold crossing state has changed

      if (shouldShowWhiteHeader !== isScrolledPast40) {
        setIsScrolledPast40(shouldShowWhiteHeader);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isScrolledPast40]);
  (0,react.useEffect)(() => {
    const authCookie = (0,utils/* getCookieByName */.A7)("mmt-auth") || (0,utils/* getCookieByName */.A7)("OAUTH-GOIBIBO");
    setIsLoggedIn(!!authCookie);
  }, []);
  const blackHeaderStyle = {
    display: isScrolledPast40 ? "none" : "block"
  };
  const whiteHeaderStyle = {
    display: isScrolledPast40 ? "block" : "none"
  };
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(LandingHeader_style/* LandingHeaderMobBlack */.GY, {
      displayWhiteHeader: displayWhiteHeader,
      id: "blackHeader",
      style: blackHeaderStyle,
      insuranceHeader: insuranceHeader,
      "data-test-id": "LandingHeaderMobile-LandingHeaderMobBlack",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components.FlexComp, {
        gap: "12px",
        alignItems: "center",
        justifyContent: displayWhiteHeader ? "flex-start" : "space-between",
        "data-test-id": "LandingHeaderMobile-FlexComp",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LandingHeaderBackButton, {
          handleBackBtn: handleBackBtn,
          showPwaHeaderBackButton: showPwaHeaderBackButton,
          exitWebViewOnBack: exitWebViewOnBack,
          "data-test-id": "LandingHeaderMobile-LandingHeaderBackButton"
        }), headerTitle && displayWhiteHeader && /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
          fontSize: "md",
          fontWeight: "bold",
          "data-test-id": "LandingHeaderMobile-SpanTag",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
            value: headerTitle,
            "data-test-id": "LandingHeaderMobile-FormattedText"
          })
        }), device == "sm" && myOrders && /*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
          width: "75px",
          height: "24px",
          src: partnerType === src.PARTNER.MMT ? "https://tripmoneycmsimgak.mmtcdn.com/img/Group_46_699159e12c.svg" : "https://tripmoneycmsimgak.mmtcdn.com/img/gi_logo_512_6736e70735.png",
          "data-test-id": "LandingHeaderMobile-ImageComponent"
        }), myOrders && isLoggedIn ? /*#__PURE__*/(0,jsx_runtime.jsx)(components.AnchorTag, {
          color: `var(--tm-accent-color)`,
          fontWeight: "bold",
          handleClick: goToMyOrders,
          "data-test-id": "LandingHeaderMobile-AnchorTag",
          children: "My Orders"
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          style: {
            width: "24px",
            height: "24px"
          }
        })]
      }), children]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(LandingHeader_style/* LandingHeaderMob */.gF, {
      id: "whiteHeader",
      style: whiteHeaderStyle,
      "data-test-id": "LandingHeaderMobile-LandingHeaderMob",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components.FlexComp, {
        gap: "12px",
        alignItems: "center",
        "data-test-id": "LandingHeaderMobile-FlexComp",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LandingHeaderBackButton, {
          handleBackBtn: handleBackBtn,
          displayWhiteHeader: true,
          exitWebViewOnBack: exitWebViewOnBack,
          "data-test-id": "LandingHeaderMobile-LandingHeaderBackButton"
        }), headerTitle && /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
          fontSize: "md",
          fontWeight: "bold",
          "data-test-id": "LandingHeaderMobile-SpanTag",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
            value: headerTitle,
            "data-test-id": "LandingHeaderMobile-FormattedText"
          })
        }), myOrders && isLoggedIn ? /*#__PURE__*/(0,jsx_runtime.jsx)(components.AnchorTag, {
          color: `var(--tm-accent-color)`,
          margin: "0 0 0 auto",
          fontWeight: "bold",
          handleClick: goToMyOrders,
          "data-test-id": "LandingHeaderMobile-AnchorTag",
          children: "My Orders"
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          style: {
            width: "24px",
            height: "24px"
          }
        })]
      }), children]
    })]
  });
};

/* harmony default export */ const LandingHeader_LandingHeaderMobile = (LandingHeaderMobile);

/***/ }),

/***/ 48741:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ LandingInput_LandingInput)
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/index.tsx + 12 modules
var components = __webpack_require__(48359);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/utils/index.tsx
var utils = __webpack_require__(84576);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/TextStyles/TextStyles.style.ts
var TextStyles_style = __webpack_require__(93139);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/LandingInput/LandingInput.style.ts



const InputWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingInputstyle__InputWrap",
  componentId: "sc-1tw2ggf-0"
})(["position:relative;display:flex;flex-direction:column;margin:", ";width:", ";flex:", ";flex-shrink:0;width:100%;label{font-weight:700;font-size:14px;line-height:16px;color:#4a4a4a;display:block;margin-bottom:8px;transition:all 0.3s ease;display:inline-block;}"], props => props.margin, props => props.inputWidth, p => p.flex ? p.flex : "");
const ErrorTxt = (0,styled_components_browser_esm/* default */.ZP)(TextStyles_style/* SpanTagStyle */.zs).withConfig({
  displayName: "LandingInputstyle__ErrorTxt",
  componentId: "sc-1tw2ggf-1"
})(["color:#eb2026;"]);
const LandingInputStyle = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
  displayName: "LandingInputstyle__LandingInputStyle",
  componentId: "sc-1tw2ggf-2"
})(["background:", ";border:1px solid #d2d2d2;border-radius:4px;padding:10px;font-weight:900;font-size:14px;line-height:19px;width:100%;height:41px;&::placeholder{font-weight:400 !important;color:rgba(0,0,0,0.3) !important;}&:focus + label{color:var(--tm-accent-color);}", " ", " @media ", "{width:calc(100vw - 32px);}", " &:focus{outline:none;border:1px solid var(--tm-accent-color);background:var(--tm-accent-bg-color);}&[type=\"number\"]::-webkit-outer-spin-button,&[type=\"number\"]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0;}&[type=\"number\"]{-moz-appearance:textfield;}"], props => props.backgroundColor || "#ffffff", props => props.disableState && `
      opacity: 0.3;
      pointer-events: none;
	`, props => props.errorState && `
      border: 1px solid #EB2026;
	`, utils/* deviceType.mobile */.vO.mobile, props => props.Verify && `
      color: var(--tm-accent-color);
      background: var(--tm-accent-bg-color);
      border: 1px solid var(--tm-accent-color);
      pointer-events: none;
	`);
const CalenderWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingInputstyle__CalenderWrap",
  componentId: "sc-1tw2ggf-3"
})(["cursor:pointer;position:absolute;right:16px;top:36px;"]);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/LandingInput/LandingInput.tsx







const LandingInput = ({
  placeholderTxt,
  labelTxt,
  disableState,
  inputWidth,
  margin,
  errorState,
  inputValue,
  handleChange,
  Verify,
  flex,
  requiredField,
  handleKeyDown,
  maxInputLength,
  inputType,
  handleFocus,
  handleBlur,
  maxValue,
  minValue,
  autoComplete = "on",
  calender,
  handleOpenCalender,
  autofocus,
  isDisabled,
  backgroundColor
}) => {
  const handleMouseWheel = event => {
    event.preventDefault();
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(InputWrap, {
    margin: margin,
    flex: flex,
    inputWidth: inputWidth,
    Verify: Verify,
    "data-test-id": "LandingInput-InputWrap",
    children: [labelTxt && /*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
      htmlFor: labelTxt,
      "data-test-id": "LandingInput-label",
      children: [labelTxt, requiredField && /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
        fontWeight: "bold",
        color: Global/* theme.redText2 */.rS.redText2,
        "data-test-id": "LandingInput-SpanTag",
        children: "*"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(LandingInputStyle, {
      onChange: handleChange,
      onFocus: handleFocus,
      onBlur: handleBlur,
      onKeyDown: handleKeyDown,
      value: inputValue,
      errorState: errorState,
      id: labelTxt,
      disableState: disableState,
      placeholder: placeholderTxt,
      maxLength: maxInputLength,
      type: inputType,
      min: minValue,
      max: maxValue,
      onWheel: handleMouseWheel,
      autoComplete: autoComplete,
      autoFocus: autofocus,
      inputWidth: inputWidth,
      disabled: isDisabled,
      backgroundColor: backgroundColor,
      "data-test-id": "LandingInput-LandingInputStyle"
    }), errorState && /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorTxt, {
      txtfontSize: "xs",
      margin: "4px 0 0",
      txtcolor: Global/* theme.redText */.rS.redText,
      txtfontWeight: "bold",
      "data-test-id": "LandingInput-ErrorTxt",
      children: errorState
    }), calender && /*#__PURE__*/(0,jsx_runtime.jsx)(CalenderWrap, {
      onClick: handleOpenCalender,
      "data-test-id": "LandingInput-CalenderWrap",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
        width: "24px",
        height: "24px",
        src: "https://tripmoneycmsimgak.mmtcdn.com/img/Calendar_b8e9e22a64.svg",
        "data-test-id": "LandingInput-ImageComponent"
      })
    })]
  });
};

/* harmony default export */ const LandingInput_LandingInput = (LandingInput);

/***/ }),

/***/ 50976:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ LandingTestimonials_LandingTestimonials)
});

// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/OmnitureAnalytics/insurance/index.ts + 5 modules
var insurance = __webpack_require__(83636);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/index.tsx + 12 modules
var components = __webpack_require__(48359);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/index.ts + 2 modules
var src = __webpack_require__(87109);
// EXTERNAL MODULE: ../../libs/ui/src/lib/hooks/index.ts + 1 modules
var hooks = __webpack_require__(89565);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/CommonStyle/CommonStyles.style.ts
var CommonStyles_style = __webpack_require__(20984);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/icons/index.ts + 7 modules
var icons = __webpack_require__(64204);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/FormattedText/FormattedText.tsx
var FormattedText = __webpack_require__(17871);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/utils/index.tsx
var utils = __webpack_require__(84576);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/TextStyles/TextStyles.style.ts
var TextStyles_style = __webpack_require__(93139);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/LandingTestimonials/LandingTestimonials.style.ts



const LandingTestimonialsStyle = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "LandingTestimonialsstyle__LandingTestimonialsStyle",
  componentId: "sc-1au5c5p-0"
})(["display:flex;background:#fff;flex-direction:column;margin-bottom:137px;width:100%;@media ", "{margin-bottom:40px;}"], utils/* deviceType.mobile */.vO.mobile);
const LandingTestTitle = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
  displayName: "LandingTestimonialsstyle__LandingTestTitle",
  componentId: "sc-1au5c5p-1"
})(["font-family:\"Lato\";font-weight:500;font-size:56px;line-height:72px;color:#000000;margin-bottom:34px;display:flex;align-items:center;@media ", "{font-size:24px;line-height:32px;margin-bottom:12px;padding:0px 16px;}"], utils/* deviceType.mobile */.vO.mobile);
const TestimonialContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingTestimonialsstyle__TestimonialContent",
  componentId: "sc-1au5c5p-2"
})(["display:flex;margin-bottom:8px;> img{margin-right:17px;border-radius:8px;}"]);
const LandingTest = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingTestimonialsstyle__LandingTest",
  componentId: "sc-1au5c5p-3"
})(["display:inline-block;img{object-fit:contain;}@media ", "{font-weight:400;color:#4a4a4a;align-items:flex-start;border-radius:10px;position:relative;background:#fff;z-index:1;width:100% !important;flex-direction:column !important;padding:4px 16px;font-size:14px;line-height:20px;}"], utils/* deviceType.mobile */.vO.mobile);
const LandingTestWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingTestimonialsstyle__LandingTestWrap",
  componentId: "sc-1au5c5p-4"
})(["display:flex;width:575px;padding:32px 30px;background:#fff;position:relative;z-index:1;border-radius:10px;margin-right:20px;", "{white-space:initial;}@media ", "{width:unset;padding:16px;", "{font-size:14px;line-height:20px;}box-shadow:0px 1px 7px rgba(0,0,0,0.2);border-radius:10px;margin-right:unset;}"], TextStyles_style/* ParaTagStyle */.OG, utils/* deviceType.mobile */.vO.mobile, TextStyles_style/* ParaTagStyle */.OG);
const LandingTestImg = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingTestimonialsstyle__LandingTestImg",
  componentId: "sc-1au5c5p-5"
})(["width:150px;height:250px;flex-shrink:0;position:relative;margin-right:20px;z-index:1;> img{border-radius:20px;}@media ", "{width:84px;height:87px;display:flex;}"], utils/* deviceType.mobile */.vO.mobile);
const LandingTextCrd = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingTestimonialsstyle__LandingTextCrd",
  componentId: "sc-1au5c5p-6"
})(["padding:4px 8px 4px 8px;border-radius:19px;font-weight:700;font-size:12px;line-height:11px;color:#fff;position:absolute;bottom:-7px;left:25px;text-transform:uppercase;", " ", " @media ", "{position:static;width:fit-content;}"], p => p.cardType == "travelLoan" && `
    background: linear-gradient(88.44deg, #43e1a8 0.02%, #28beb2 100.01%);
    `, p => p.cardType == "forexCard" && `
    background: linear-gradient(85.23deg, #ff7f3f 0%, #ff3e5e 100%);
    `, utils/* deviceType.mobile */.vO.mobile);
const PersonName = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "LandingTestimonialsstyle__PersonName",
  componentId: "sc-1au5c5p-7"
})(["font-weight:700;font-size:24px;line-height:36px;color:#012136;margin-bottom:2px;display:block;@media ", "{font-size:16px;line-height:20px;font-weight:900;}"], utils/* deviceType.mobile */.vO.mobile);
const LandingTestimonials_style_Date = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "LandingTestimonialsstyle__Date",
  componentId: "sc-1au5c5p-8"
})(["font-weight:400;font-size:14px;line-height:18px;color:#9b9b9b;@media ", "{font-size:12px;}"], utils/* deviceType.mobile */.vO.mobile);
const LandingTestCntnt = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingTestimonialsstyle__LandingTestCntnt",
  componentId: "sc-1au5c5p-9"
})(["z-index:1;@media ", "{white-space:initial;}"], utils/* deviceType.mobile */.vO.mobile);
const Flex = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingTestimonialsstyle__Flex",
  componentId: "sc-1au5c5p-10"
})(["display:flex;width:100%;margin-bottom:8px;"]);
const SlideShowContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingTestimonialsstyle__SlideShowContainer",
  componentId: "sc-1au5c5p-11"
})(["margin:0 auto;overflow:hidden;max-width:1200px;@media ", "{max-width:100%;cursor:grab;}"], utils/* deviceType.mobile */.vO.mobile);
const SlideShowSLider = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingTestimonialsstyle__SlideShowSLider",
  componentId: "sc-1au5c5p-12"
})(["white-space:nowrap;transition:ease 1000ms;"]);
const SlideDots = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingTestimonialsstyle__SlideDots",
  componentId: "sc-1au5c5p-13"
})(["text-align:center;@media ", "{margin-top:12px;}"], utils/* deviceType.mobile */.vO.mobile);
const SlideShowDotItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingTestimonialsstyle__SlideShowDotItem",
  componentId: "sc-1au5c5p-14"
})(["background:#3f3d56;opacity:0.2;width:12px;height:12px;border-radius:100%;display:inline-block;margin-right:16px;cursor:pointer;", ""], p => p.active && `
        width: 32px;
        height: 12px;
        background: #000000 !important;
        opacity: 1;
        border-radius: 6px;
        `);
const StarRating = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingTestimonialsstyle__StarRating",
  componentId: "sc-1au5c5p-15"
})(["display:flex;gap:8px;", " @media ", "{gap:5px;}"], p => p.starRateFull && `
    position: absolute;
    top: 0;
    `, utils/* deviceType.mobile */.vO.mobile);
const StarRatingWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingTestimonialsstyle__StarRatingWrap",
  componentId: "sc-1au5c5p-16"
})(["margin-bottom:12px;position:relative;"]);
const TestimonialTag = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingTestimonialsstyle__TestimonialTag",
  componentId: "sc-1au5c5p-17"
})(["background:rgba(120,198,255,0.2);border:1px solid rgba(120,198,255,0.4);border-radius:8px;padding:2px 12px;"]);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/LandingTestimonials/LandingTestimonials.tsx













const LandingTestimonials = ({
  customTitle,
  test
}) => {
  const {
    0: currentIndex,
    1: setCurrentIndex
  } = (0,react.useState)(0);
  const {
    0: length,
    1: setLength
  } = (0,react.useState)(test?.length);
  const {
    0: touchPosition,
    1: setTouchPosition
  } = (0,react.useState)(null);
  const device = (0,src/* useBreakpointV2 */.bU)();
  const {
    0: isHovered,
    1: setIsHovered
  } = (0,react.useState)(false);
  const analytics = (0,insurance/* getAnalytics */.I)();
  const hasTracked = (0,react.useRef)(false); // Track component view when it comes into viewport

  const handleIntersection = (0,react.useCallback)(data => {
    if (!hasTracked.current) {
      analytics?.trackLandingEvents({
        actionType: "landing_testimonials_seen"
      });
    }

    hasTracked.current = true;
  }, []);
  const {
    ref: testimonialsRef
  } = (0,hooks/* useIntersectionObserver */.S)(handleIntersection, {
    threshold: 0.5,
    // Trigger when 50% of component is visible
    triggerOnLeaveViewport: true
  });
  (0,react.useEffect)(() => {
    setLength(test?.length);
  }, [test]);

  const next = () => {
    if (currentIndex < length - 1) {
      setCurrentIndex(prevState => prevState + 1);
    }
  };

  const prev = () => {
    if (currentIndex > 0) {
      setCurrentIndex(prevState => prevState - 1);
    }
  };

  const handleTouchStart = e => {
    const touchDown = e.touches[0].clientX;
    setTouchPosition(touchDown);
  };

  const handleTouchMove = e => {
    const touchDown = touchPosition;

    if (touchDown === null) {
      return;
    }

    const currentTouch = e.touches[0].clientX;
    const diff = touchDown - currentTouch;

    if (diff > 5) {
      next();
    }

    if (diff < -5) {
      prev();
    }

    setTouchPosition(null);

    if (isHovered) {
      resetTimeout();
    }
  };

  const timeoutRef = react.useRef(null);

  function resetTimeout() {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  }

  react.useEffect(() => {
    resetTimeout();
    timeoutRef.current = window.setTimeout(() => setCurrentIndex(prevIndex => prevIndex === test?.length - 1 ? 0 : prevIndex + 1), 2500);
    return () => {
      resetTimeout();
      timeoutRef.current = window.setTimeout(() => setCurrentIndex(prevIndex => prevIndex === test?.length - 1 ? 0 : prevIndex + 1), 2500);
    };
  }, [currentIndex]);

  const handleMouseEnter = () => {
    setIsHovered(true);
    resetTimeout();
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
    resetTimeout();
    timeoutRef.current = window.setTimeout(() => setCurrentIndex(prevIndex => prevIndex === test?.length - 1 ? 0 : prevIndex + 1), 2500);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(LandingTestimonialsStyle, {
    ref: testimonialsRef,
    "data-test-id": "LandingTestimonials-LandingTestimonialsStyle",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(CommonStyles_style/* InnerContentWrap */.I, {
      "data-test-id": "LandingTestimonials-InnerContentWrap",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(LandingTestTitle, {
        "data-test-id": "LandingTestimonials-LandingTestTitle",
        children: [customTitle && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
          value: customTitle,
          "data-test-id": "LandingTestimonials-FormattedText"
        }), " ", /*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
          width: device == "lg" ? "66px" : "32px",
          height: device == "lg" ? "66px" : "32px",
          src: "https://tripmoneycmsimgak.mmtcdn.com/img/heart_9289dd4a1d.svg",
          "data-test-id": "LandingTestimonials-ImageComponent"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(SlideShowContainer, {
        onTouchStart: handleTouchStart,
        onTouchMove: handleTouchMove,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        "data-test-id": "LandingTestimonials-SlideShowContainer",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SlideShowSLider, {
          style: {
            transform: `translateX(-${currentIndex * (device === "lg" ? 50 : 100)}%)`
          },
          "data-test-id": "LandingTestimonials-SlideShowSLider",
          children: test && test.map((item, index) => {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(LandingTest, {
              "data-test-id": `LandingTestimonials-LandingTest-${index}`,
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)(LandingTestWrap, {
                "data-test-id": "LandingTestimonials-LandingTestWrap",
                children: [device === "lg" && /*#__PURE__*/(0,jsx_runtime.jsxs)(LandingTestImg, {
                  "data-test-id": "LandingTestimonials-LandingTestImg",
                  children: [item.personImg && /*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
                    width: "150",
                    height: "250",
                    alt: "hello",
                    src: item.personImg.src,
                    "data-test-id": "LandingTestimonials-ImageComponent"
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(LandingTextCrd, {
                    cardType: item.personCrdClass,
                    "data-test-id": "LandingTestimonials-LandingTextCrd",
                    children: item.personCard && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
                      value: item.personCard,
                      "data-test-id": "LandingTestimonials-FormattedText"
                    })
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)(LandingTestCntnt, {
                  "data-test-id": "LandingTestimonials-LandingTestCntnt",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TestimonialContent, {
                    "data-test-id": "LandingTestimonials-TestimonialContent",
                    children: [device !== "lg" && item.personImg && /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                      width: "84",
                      height: "87",
                      alt: "",
                      src: item.personImg.src
                    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PersonName, {
                        "data-test-id": "LandingTestimonials-PersonName",
                        children: item.personName && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
                          value: item.personName,
                          "data-test-id": "LandingTestimonials-FormattedText"
                        })
                      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(StarRatingWrap, {
                        "data-test-id": "LandingTestimonials-StarRatingWrap",
                        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StarRating, {
                          "data-test-id": "LandingTestimonials-StarRating",
                          children: Array.from({
                            length: 5
                          }, (_, index) => /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* StarEmpty */.rj, {
                            height: device !== "lg" ? 16 : 25,
                            width: device !== "lg" ? 16 : 26,
                            "data-test-id": `LandingTestimonials-StarEmpty-${index}`
                          }, index))
                        }), /*#__PURE__*/(0,jsx_runtime.jsx)(StarRating, {
                          starRateFull: true,
                          "data-test-id": "LandingTestimonials-StarRating",
                          children: Array.from({
                            length: Number(item.personRating)
                          }, (_, index) => /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* StarFull */.Um, {
                            height: device !== "lg" ? 16 : 25,
                            width: device !== "lg" ? 16 : 26,
                            "data-test-id": `LandingTestimonials-StarFull-${index}`
                          }, index))
                        })]
                      }), device !== "lg" && /*#__PURE__*/(0,jsx_runtime.jsx)(LandingTextCrd, {
                        "data-test-id": "LandingTestimonials-LandingTextCrd",
                        children: item.personCard && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
                          value: item.personCard,
                          "data-test-id": "LandingTestimonials-FormattedText"
                        })
                      })]
                    })]
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.ParaTag, {
                    fontSize: "md",
                    color: Global/* theme.greyText */.rS.greyText,
                    "data-test-id": "LandingTestimonials-ParaTag",
                    children: item.testInfo && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
                      value: item.testInfo,
                      "data-test-id": "LandingTestimonials-FormattedText"
                    })
                  })]
                })]
              })
            }, index);
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SlideDots, {
          "data-test-id": "LandingTestimonials-SlideDots",
          children: test?.map((_, idx) => /*#__PURE__*/(0,jsx_runtime.jsx)(SlideShowDotItem, {
            active: currentIndex === idx,
            onClick: () => {
              setCurrentIndex(idx);
            },
            "data-test-id": `LandingTestimonials-SlideShowDotItem-${idx}`
          }, idx))
        })]
      })]
    })
  });
};

/* harmony default export */ const LandingTestimonials_LandingTestimonials = (LandingTestimonials);

/***/ }),

/***/ 85167:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ ListingEditDetails_ListingEditDetails)
});

// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/OmnitureAnalytics/insurance/index.ts + 5 modules
var insurance = __webpack_require__(83636);
// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/XDMAnalytics/index.ts
var XDMAnalytics = __webpack_require__(50354);
// EXTERNAL MODULE: ../../libs/utility/src/lib/insurance/navigation/index.ts + 5 modules
var navigation = __webpack_require__(576);
// EXTERNAL MODULE: ../../libs/utility/src/lib/insurance/utils/index.ts + 5 modules
var utils = __webpack_require__(62663);
// EXTERNAL MODULE: ../../libs/isomorphic-utils/src/index.ts + 7 modules
var src = __webpack_require__(44928);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/index.tsx + 12 modules
var components = __webpack_require__(48359);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/utils/PartnerContextProvider.tsx
var PartnerContextProvider = __webpack_require__(58524);
// EXTERNAL MODULE: ../../libs/ui/src/index.ts
var ui_src = __webpack_require__(76609);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/index.ts + 2 modules
var ui_widgets_src = __webpack_require__(87109);
// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/index.ts + 7 modules
var analytics = __webpack_require__(11508);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/CountryFormatter/index.tsx
var CountryFormatter = __webpack_require__(78525);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/FormattedText/FormattedText.tsx
var FormattedText = __webpack_require__(17871);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/TextStyles/TextStyles.style.ts
var TextStyles_style = __webpack_require__(93139);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/FlexComp/FlexComp.style.ts
var FlexComp_style = __webpack_require__(88025);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ListingEditDetails/ListingEditDetails.style.ts





const ListingEditDetailsStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ListingEditDetailsstyle__ListingEditDetailsStyle",
  componentId: "sc-18qpjo8-0"
})(["background:#fff;border:1px solid rgba(242,242,242,0.16);border-radius:8px;padding:24px;& > ", ":first-child{margin-bottom:8px;}@media ", "{padding:12px 16px;& > ", ":first-child{margin-bottom:0px;}}"], FlexComp_style/* FlexCompStyle */.l, src.deviceType.mobile, FlexComp_style/* FlexCompStyle */.l);
const ListingWidgetDetails = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ListingEditDetailsstyle__ListingWidgetDetails",
  componentId: "sc-18qpjo8-1"
})(["background:#f6f6f6;border-radius:4px;padding:12px;"]);
const ListingSpan = (0,styled_components_browser_esm/* default */.ZP)(TextStyles_style/* SpanTagStyle */.zs).withConfig({
  displayName: "ListingEditDetailsstyle__ListingSpan",
  componentId: "sc-18qpjo8-2"
})(["font-size:14px;line-height:20px;color:", ";padding-right:12px;margin-right:12px;position:relative;flex-shrink:0;&:last-child{border:none;flex-shrink:unset;}&:after{content:\"\";position:absolute;right:0;top:4px;width:1px;height:14px;background:#000;}&:last-child:after{width:0;}@media ", "{font-size:12px;}"], Global/* theme.blackText */.rS.blackText, src.deviceType.mobile);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ListingEditDetails/ListingEditDetails.tsx
















const ListingEditDetails_analytics = (0,insurance/* getAnalytics */.I)();

const ListingEditDetails = ({
  mode,
  title,
  travelPurpose,
  travelDates,
  travellerCount,
  showEditIcon
}) => {
  const device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  const {
    startDate,
    endDate
  } = travelDates || {};
  const {
    type
  } = (0,ui_src/* usePlanType */.U)();
  const context = (0,PartnerContextProvider/* usePartnerContext */.X)();

  const handleEditClick = () => {
    ListingEditDetails_analytics?.trackListingEvents({
      actionType: "edit_clicked"
    }, "pageView", type);
    (0,XDMAnalytics.trackEvent)({
      event_detail: {
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: "edit_clicked"
      }
    });
    const queryParams = new URLSearchParams(window.location.search);
    const params = {
      countries: queryParams.get("countries"),
      startDate: queryParams.get("startDate"),
      endDate: queryParams.get("endDate"),
      travellers: queryParams.get("travellers"),
      segment: queryParams.get("segment"),
      type: queryParams.get("type") || "",
      tripOption: queryParams.get("tripOption") || "",
      planType: queryParams.get("planType") || ""
    };

    if ((0,utils/* getCookieByName */.A7)("isCommonLanding") === "true" && !queryParams.get("type")) {
      (0,analytics/* storePageTransitionStart */.SE)("listing");
      navigation/* navigationActions.navigateToCommonLanding */.ej.navigateToCommonLanding(params); // const HOSTNAME = window.location.hostname;
      // navigationActions.navigateToRouteNameWithHostname(
      //   ROUTE_CONSTANTS.COMMON_LANDING,
      //   params
      // );
      //TODO: aDD This once we have the common landing page for seo
    } else {
      navigation/* navigationActions.navigateToLanding */.ej.navigateToLanding(params, false);
    }
  }; //TODO: Remove conditional icons logic everywhere for myBiz and use css var + data-theme for it


  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ListingEditDetailsStyle, {
    "data-test-id": "ListingEditDetails-ListingEditDetailsStyle",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components.FlexComp, {
      alignItems: "enter",
      justifyContent: "space-between",
      flexWrap: "wrap",
      "data-test-id": "ListingEditDetails-FlexComp",
      children: [device == "lg" ? /*#__PURE__*/(0,jsx_runtime.jsx)(components.H5Tag, {
        color: Global/* theme.blackText */.rS.blackText,
        "data-test-id": "ListingEditDetails-H5Tag",
        children: title && /*#__PURE__*/(0,jsx_runtime.jsx)(CountryFormatter/* default */.Z, {
          title: title,
          "data-test-id": "ListingEditDetails-CountryFormatter"
        })
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(components.ParaTag, {
        fontSize: "md",
        fontWeight: "black",
        color: Global/* theme.blackText */.rS.blackText,
        "data-test-id": "ListingEditDetails-ParaTag",
        children: title && /*#__PURE__*/(0,jsx_runtime.jsx)(CountryFormatter/* default */.Z, {
          title: title,
          "data-test-id": "ListingEditDetails-CountryFormatter"
        })
      }), showEditIcon && /*#__PURE__*/(0,jsx_runtime.jsx)(components.AnchorTag, {
        handleClick: handleEditClick,
        "data-test-id": "ListingEditDetails-AnchorTag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
          width: "25px",
          height: "25px",
          src: context === src.PARTNER.MYBIZ ? "https://tripmoneycmsimgak.mmtcdn.com/img/Icon_Group_356e8bd372.png" : "https://tripmoneycmsimgak.mmtcdn.com/img/edit_Icon_be6c24806a.svg",
          "data-test-id": "ListingEditDetails-ImageComponent"
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components.FlexComp, {
      "data-test-id": "ListingEditDetails-FlexComp",
      children: [mode && /*#__PURE__*/(0,jsx_runtime.jsx)(ListingSpan, {
        color: Global/* theme.blackText */.rS.blackText,
        "data-test-id": "ListingEditDetails-ListingSpan",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
          fontSize: "md",
          color: Global/* theme.blackText */.rS.blackText,
          "data-test-id": "ListingEditDetails-SpanTag",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
            value: mode,
            "data-test-id": "ListingEditDetails-FormattedText"
          })
        })
      }), startDate && endDate && /*#__PURE__*/(0,jsx_runtime.jsxs)(ListingSpan, {
        color: Global/* theme.blackText */.rS.blackText,
        "data-test-id": "ListingEditDetails-ListingSpan",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components.SpanTag, {
          color: Global/* theme.blackText */.rS.blackText,
          fontSize: "md",
          fontWeight: "black",
          "data-test-id": "ListingEditDetails-SpanTag",
          children: [(0,utils/* formatDate */.p6)(startDate, src.DATE_FORMATS["D MMM"]), "'"]
        }), (0,utils/* formatDate */.p6)(startDate, src.DATE_FORMATS.YY), " -To-", " ", /*#__PURE__*/(0,jsx_runtime.jsxs)(components.SpanTag, {
          color: Global/* theme.blackText */.rS.blackText,
          fontSize: "md",
          fontWeight: "black",
          "data-test-id": "ListingEditDetails-SpanTag",
          children: [(0,utils/* formatDate */.p6)(endDate, src.DATE_FORMATS["D MMM"]), "'"]
        }), (0,utils/* formatDate */.p6)(endDate, src.DATE_FORMATS.YY)]
      }), travellerCount && travellerCount > 0 ? /*#__PURE__*/(0,jsx_runtime.jsxs)(ListingSpan, {
        color: Global/* theme.blackText */.rS.blackText,
        "data-test-id": "ListingEditDetails-ListingSpan",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components.SpanTag, {
          color: Global/* theme.blackText */.rS.blackText,
          fontSize: "md",
          fontWeight: "bold",
          "data-test-id": "ListingEditDetails-SpanTag",
          children: [travellerCount, "\xA0"]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
          color: Global/* theme.blackText */.rS.blackText,
          fontSize: "md",
          "data-test-id": "ListingEditDetails-SpanTag",
          children: travellerCount > 1 ? "Travellers" : "Traveller"
        })]
      }) : null]
    })]
  });
};

/* harmony default export */ const ListingEditDetails_ListingEditDetails = (ListingEditDetails);

/***/ }),

/***/ 10633:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ ListingTravelDetails_ListingTravelDetails)
});

// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/OmnitureAnalytics/insurance/index.ts + 5 modules
var insurance = __webpack_require__(83636);
// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/XDMAnalytics/index.ts
var XDMAnalytics = __webpack_require__(50354);
// EXTERNAL MODULE: ../../libs/utility/src/lib/insurance/navigation/index.ts + 5 modules
var navigation = __webpack_require__(576);
// EXTERNAL MODULE: ../../libs/isomorphic-utils/src/index.ts + 7 modules
var src = __webpack_require__(44928);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/index.tsx + 12 modules
var components = __webpack_require__(48359);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/utils/PartnerContextProvider.tsx
var PartnerContextProvider = __webpack_require__(58524);
// EXTERNAL MODULE: ../../libs/ui/src/index.ts
var ui_src = __webpack_require__(76609);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/index.ts + 2 modules
var ui_widgets_src = __webpack_require__(87109);
// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/index.ts + 7 modules
var analytics = __webpack_require__(11508);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/utils/index.tsx
var utils = __webpack_require__(84576);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ListingTravelDetails/ListingTravelDetails.style.ts


const ListingTravelDetailsStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ListingTravelDetailsstyle__ListingTravelDetailsStyle",
  componentId: "za921k-0"
})(["background:#fff;border:1px solid rgba(242,242,242,0.16);border-radius:8px;padding:24px;@media ", "{padding:12px 16px;}"], utils/* deviceType.mobile */.vO.mobile);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ListingTravelDetails/ListingTravelDetails.tsx













const ListingTravelDetails_analytics = (0,insurance/* getAnalytics */.I)();

const ListingTravelDetails = ({
  data,
  tnc,
  handleTnc,
  handleViewBenefits,
  previewBenefits,
  vendorDisplayIcon,
  addOnProductDetails
}) => {
  const device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  const {
    type
  } = (0,ui_src/* usePlanType */.U)();
  const context = (0,PartnerContextProvider/* usePartnerContext */.X)();
  const {
    planType,
    planName,
    sumInsured,
    amountToPay,
    editEnabled,
    priceDetails
  } = data || {};

  const handleEditClick = () => {
    ListingTravelDetails_analytics?.trackTravDetailsEvents({
      actionType: "edit_product_clicked"
    }, "pageView", type);
    (0,XDMAnalytics.trackEvent)({
      event_detail: {
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: "edit_product_clicked"
      }
    });
    const queryParams = new URLSearchParams(window.location.search);
    const params = {
      countries: queryParams.get("countries"),
      startDate: queryParams.get("startDate"),
      endDate: queryParams.get("endDate"),
      travellers: queryParams.get("travellers"),
      segment: queryParams.get("segment"),
      type: queryParams.get("type") || "",
      itineraryId: queryParams.get("itineraryId") || ""
    };
    (0,analytics/* storePageTransitionStart */.SE)("traveller_details");
    navigation/* navigationActions.navigateToListing */.ej.navigateToListing(params);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ListingTravelDetailsStyle, {
    "data-test-id": "ListingTravelDetails-ListingTravelDetailsStyle",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components.FlexComp, {
      margin: "0 0 4px",
      justifyContent: "space-between",
      "data-test-id": "ListingTravelDetails-FlexComp",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: [planType && /*#__PURE__*/(0,jsx_runtime.jsx)(components.ParaTag, {
          fontSize: "xs",
          fontWeight: "black",
          margin: "0 0 4px",
          "data-test-id": "ListingTravelDetails-ParaTag",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
            value: planType,
            "data-test-id": "ListingTravelDetails-FormattedText"
          })
        }), addOnProductDetails?.productTitle ? /*#__PURE__*/(0,jsx_runtime.jsx)(components.ParaTag, {
          color: Global/* theme.blackText */.rS.blackText,
          fontWeight: "black",
          fontSize: "md",
          "data-test-id": "ListingTravelDetails-ParaTag",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
            value: addOnProductDetails?.productTitle,
            "data-test-id": "ListingTravelDetails-FormattedText"
          })
        }) : planName && /*#__PURE__*/(0,jsx_runtime.jsx)(components.ParaTag, {
          color: Global/* theme.blackText */.rS.blackText,
          fontWeight: "black",
          fontSize: "md",
          "data-test-id": "ListingTravelDetails-ParaTag",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
            value: planName,
            "data-test-id": "ListingTravelDetails-FormattedText"
          })
        })]
      }), previewBenefits ? /*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
        width: "38px",
        height: "38px",
        src: vendorDisplayIcon,
        "data-test-id": "ListingTravelDetails-ImageComponent"
      }) : editEnabled && /*#__PURE__*/(0,jsx_runtime.jsx)(components.AnchorTag, {
        handleClick: handleEditClick,
        "data-test-id": "ListingTravelDetails-AnchorTag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
          width: "25px",
          height: "25px",
          src: context === src.PARTNER.MYBIZ ? "https://tripmoneycmsimgak.mmtcdn.com/img/Icon_Group_356e8bd372.png" : "https://tripmoneycmsimgak.mmtcdn.com/img/edit_Icon_be6c24806a.svg",
          "data-test-id": "ListingTravelDetails-ImageComponent"
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.FlexComp, {
      borderBottom: previewBenefits ? "" : "1px solid rgba(242, 242, 242, 0.2)",
      alignItems: device == "lg" ? "center" : "flex-start",
      gap: "6px",
      margin: "0 0 8px",
      padding: "0 0 8px",
      flexDirection: device == "lg" ? "row" : "column",
      "data-test-id": "ListingTravelDetails-FlexComp",
      children: sumInsured && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
          fontWeight: "bold",
          color: Global/* theme.blackText */.rS.blackText,
          fontSize: device == "lg" ? "sm" : "xs",
          "data-test-id": "ListingTravelDetails-SpanTag",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
            value: sumInsured,
            "data-test-id": "ListingTravelDetails-FormattedText"
          })
        })
      })
    }), previewBenefits && /*#__PURE__*/(0,jsx_runtime.jsxs)(components.FlexComp, {
      borderBottom: "1px solid rgba(242, 242, 242, 0.2)",
      flexDirection: "column",
      margin: "-8px 0 4px",
      padding: "0 0 4px",
      "data-test-id": "ListingTravelDetails-FlexComp",
      children: [previewBenefits?.benefits?.[0].features?.map?.(item => {
        return /*#__PURE__*/(0,jsx_runtime.jsxs)(components.FlexComp, {
          justifyContent: "space-between",
          "data-test-id": "ListingTravelDetails-FlexComp",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components.FlexComp, {
            justifyContent: "space-between",
            "data-test-id": "ListingTravelDetails-FlexComp",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
              width: "16px",
              height: "16px",
              src: item?.icon,
              margin: "0 20px 4px 0",
              "data-test-id": "ListingTravelDetails-ImageComponent"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
              color: Global/* theme.blackText */.rS.blackText,
              fontSize: "xs",
              "data-test-id": "ListingTravelDetails-SpanTag",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
                value: item.name,
                "data-test-id": "ListingTravelDetails-FormattedText"
              })
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
            color: Global/* theme.blackText */.rS.blackText,
            fontSize: "xs",
            fontWeight: "bold",
            "data-test-id": "ListingTravelDetails-SpanTag",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
              value: item.cover,
              "data-test-id": "ListingTravelDetails-FormattedText"
            })
          })]
        });
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.AnchorTag, {
        targetProp: "_blank",
        handleClick: handleViewBenefits,
        "data-test-id": "ListingTravelDetails-AnchorTag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
          value: previewBenefits?.ctaText,
          baseStyle: {
            fontWeight: "700",
            fontSize: "12px"
          },
          "data-test-id": "ListingTravelDetails-FormattedText"
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components.FlexComp, {
      alignItems: "center",
      gap: "4px",
      justifyContent: "space-between",
      "data-test-id": "ListingTravelDetails-FlexComp",
      children: [priceDetails ? /*#__PURE__*/(0,jsx_runtime.jsx)(components.FlexComp, {
        alignItems: "center",
        gap: "4px",
        "data-test-id": "ListingTravelDetails-FlexComp",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(components.SpanTag, {
          color: Global/* theme.blackText */.rS.blackText,
          fontSize: device == "lg" ? "md" : "sm",
          "data-test-id": "ListingTravelDetails-SpanTag",
          children: [priceDetails?.title && /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
            value: priceDetails?.title,
            "data-test-id": "ListingTravelDetails-FormattedText"
          }), priceDetails?.originalPrice && /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
            value: addOnProductDetails?.originalAmountToPay ? addOnProductDetails?.originalAmountToPay : priceDetails?.originalPrice,
            baseStyle: {
              textDecoration: "line-through",
              textDecorationThickness: 0.8
            },
            "data-test-id": "ListingTravelDetails-FormattedText"
          }), priceDetails?.discountedPrice && /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
            value: addOnProductDetails?.totalAmountToPay ? addOnProductDetails?.totalAmountToPay : priceDetails?.discountedPrice,
            baseStyle: {
              fontWeight: 900
            },
            "data-test-id": "ListingTravelDetails-FormattedText"
          })]
        })
      }) : amountToPay && /*#__PURE__*/(0,jsx_runtime.jsx)(components.FlexComp, {
        alignItems: "center",
        gap: "4px",
        "data-test-id": "ListingTravelDetails-FlexComp",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
          color: Global/* theme.blackText */.rS.blackText,
          fontSize: device == "lg" ? "md" : "sm",
          "data-test-id": "ListingTravelDetails-SpanTag",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
            value: amountToPay,
            "data-test-id": "ListingTravelDetails-FormattedText"
          })
        })
      }), tnc?.title && /*#__PURE__*/(0,jsx_runtime.jsx)(components.AnchorTag, {
        targetProp: "_blank",
        handleClick: handleTnc,
        hrefProp: addOnProductDetails?.tncLink ? addOnProductDetails?.tncLink : tnc.url,
        fontSize: "xs",
        fontWeight: "black",
        "data-test-id": "ListingTravelDetails-AnchorTag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
          value: tnc.title,
          "data-test-id": "ListingTravelDetails-FormattedText"
        })
      })]
    })]
  });
};

/* harmony default export */ const ListingTravelDetails_ListingTravelDetails = (ListingTravelDetails);

/***/ })

}]);